
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2TzCj", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

function $c594f0c4919c867d$export$f50ba6ebca86afae(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Chat;
}
function $c594f0c4919c867d$export$e0faf22bf5023c5e(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Nested;
}
function $c594f0c4919c867d$export$ce07703e397785f3(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Skill;
}
function $c594f0c4919c867d$export$38d6fa0daaae0008(action) {
    return action.handleType === (0, $6iWVH.HandleActionType).Skill && 'dynamicPrompt' in action && (0, $6iWVH.LEGACY_DYNAMIC_SKILL_IDS).has(action.id);
}
function $c594f0c4919c867d$export$426fd22b878fe58d(action) {
    return $c594f0c4919c867d$export$f50ba6ebca86afae(action) || $c594f0c4919c867d$export$e0faf22bf5023c5e(action) || $c594f0c4919c867d$export$ce07703e397785f3(action);
}
module.exports["isChatAction"] = $c594f0c4919c867d$export$f50ba6ebca86afae;
module.exports["isNestedAction"] = $c594f0c4919c867d$export$e0faf22bf5023c5e;
module.exports["isSkillAction"] = $c594f0c4919c867d$export$ce07703e397785f3;

});

parcelRegister("iiDOK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iehIX = parcelRequire("iehIX");

const $921dd5c9e20b74d2$export$b97fe97a2a407fce = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $iehIX.SplitViewContext));
} : ()=>(0, $cozmU.useContext)((0, $iehIX.SplitViewContext));
module.exports["useSplitView"] = $921dd5c9e20b74d2$export$b97fe97a2a407fce;

});

parcelRegister("iehIX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jEK83 = parcelRequire("jEK83");

const $d2139e3561c828e8$var$openWithRequestedPresentation = (requestedPresentation)=>requestedPresentation;
const $d2139e3561c828e8$export$9dcf8f238ea334c6 = /*#__PURE__*/ (0, $cozmU.createContext)({
    presentation: null,
    openSessionContext: $d2139e3561c828e8$var$openWithRequestedPresentation,
    closeSessionContext: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
});
module.exports["SplitViewContext"] = $d2139e3561c828e8$export$9dcf8f238ea334c6;

});

parcelRegister("2XyGK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// Published Rovo packages cannot depend on the private inferred-project page, so the product that
// can registers the whole popup here and the For You rows open it.
let $a6db1a8d9040c3cd$var$registered;
const $a6db1a8d9040c3cd$var$listeners = new Set();
const $a6db1a8d9040c3cd$export$5e719f25541d8201 = (content)=>{
    $a6db1a8d9040c3cd$var$registered = content;
    $a6db1a8d9040c3cd$var$listeners.forEach((listener)=>listener());
};
const $a6db1a8d9040c3cd$var$subscribe = (listener)=>{
    $a6db1a8d9040c3cd$var$listeners.add(listener);
    return ()=>{
        $a6db1a8d9040c3cd$var$listeners.delete(listener);
    };
};
const $a6db1a8d9040c3cd$var$getSnapshot = ()=>$a6db1a8d9040c3cd$var$registered;
const $a6db1a8d9040c3cd$export$8753f6cfc689e265 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useSyncExternalStore)($a6db1a8d9040c3cd$var$subscribe, $a6db1a8d9040c3cd$var$getSnapshot, $a6db1a8d9040c3cd$var$getSnapshot);
} : ()=>(0, $cozmU.useSyncExternalStore)($a6db1a8d9040c3cd$var$subscribe, $a6db1a8d9040c3cd$var$getSnapshot, $a6db1a8d9040c3cd$var$getSnapshot);
const $a6db1a8d9040c3cd$export$ecd5f73ceb7f042b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (content)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    let t1;
    if ($[0] !== content) {
        t0 = ()=>$a6db1a8d9040c3cd$export$5e719f25541d8201(content);
        t1 = [
            content
        ];
        $[0] = content;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (content)=>{
    (0, $cozmU.useEffect)(()=>$a6db1a8d9040c3cd$export$5e719f25541d8201(content), [
        content
    ]);
};
module.exports["registerInferredProjectPopupContent"] = $a6db1a8d9040c3cd$export$5e719f25541d8201;
module.exports["useInferredProjectPopupContent"] = $a6db1a8d9040c3cd$export$8753f6cfc689e265;

});

parcelRegister("5uiWK", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

const $f650f5d03c59255a$var$supportedPageContextTypes = [
    (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW,
    (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT
];
const $f650f5d03c59255a$export$c2a686cb0530eec8 = (pageContextType)=>{
    return $f650f5d03c59255a$var$supportedPageContextTypes.includes(pageContextType);
};
module.exports["isPageContextTypeSupportedForDynamicStarters"] = $f650f5d03c59255a$export$c2a686cb0530eec8;

});

parcelRegister("bQmvI", function(module, exports) {

var $6iWVH = parcelRequire("6iWVH");

const $1fc19c5e39a1bbf3$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $1fc19c5e39a1bbf3$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($1fc19c5e39a1bbf3$export$10c6f1bef31d587c.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
const $1fc19c5e39a1bbf3$export$ee833111bcbf78d7 = (url, pageContextType)=>{
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT || pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT) {
        // Match: /pages/edit-v2/{resourceId} or /blog/edit-v2/{resourceId}
        const match = url.match(/\/(?:pages|blog)\/edit-v2\/(\d+)/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW) {
        // Page pattern: /pages/{resourceId}/
        const match = url.match(/\/pages\/(\d+)(?:\/|$|[?#])/);
        return match ? match[1] : null;
    }
    if (pageContextType === (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW) {
        // Blog pattern: /blog/{year}/{month}/{day}/{resourceId}/
        const match = url.match(/\/blog\/\d{4}\/\d{2}\/\d{2}\/(\d+)/);
        return match ? match[1] : null;
    }
    return null;
};
const $1fc19c5e39a1bbf3$export$3bb5b6748490a3c9 = (siteId, contentUrl, pageContextType)=>{
    const resourceId = $1fc19c5e39a1bbf3$export$ee833111bcbf78d7(contentUrl, pageContextType);
    if (!resourceId) return null;
    const isBlogPost = /\/spaces\/[^\/]+\/blog\//.test(contentUrl);
    const resourceType = isBlogPost ? 'blogpost' : 'page';
    return $1fc19c5e39a1bbf3$export$6a2f2c83863e9bfe({
        siteId: siteId,
        resourceType: resourceType,
        activationId: '',
        resourceId: // Not needed for pages/blogposts
        resourceId
    });
};
module.exports["getContentAri"] = $1fc19c5e39a1bbf3$export$3bb5b6748490a3c9;

});

parcelRegister("lFQjm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");

const $d4fc531cc0ae7b89$export$46133998910543ac = (0, $cozmU.createContext)(null);
const $d4fc531cc0ae7b89$export$6fa751d66e55d2e1 = (usePathname)=>{
    const [location, setLocation] = (0, $cozmU.useState)(usePathname ? window.location.pathname : window.location.href);
    // For easier mocking
    const contextValue = (0, $cozmU.useContext)($d4fc531cc0ae7b89$export$46133998910543ac);
    const handleLocationChange = (0, $cozmU.useCallback)(()=>{
        const newValue = usePathname ? window.location.pathname : window.location.href;
        if (newValue !== location) setLocation(newValue);
    }, [
        location,
        setLocation,
        usePathname
    ]);
    (0, $cozmU.useEffect)(()=>{
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args_0) {
            originalReplaceState.apply(this, args_0);
            handleLocationChange();
        };
        const unbind = (0, $cbY7C.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $d4fc531cc0ae7b89$export$6fa751d66e55d2e1;

});

parcelRegister("csz0J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $jXXTm = parcelRequire("jXXTm");


var $mfdwv = parcelRequire("mfdwv");


var $f0b2F = parcelRequire("f0b2F");


var $1TvTa = parcelRequire("1TvTa");


var $5n93X = parcelRequire("5n93X");


var $aooxV = parcelRequire("aooxV");


var $4s4Os = parcelRequire("4s4Os");


var $hAgam = parcelRequire("hAgam");


var $11OF7 = parcelRequire("11OF7");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $gzMZq = parcelRequire("gzMZq");


var $6iWVH = parcelRequire("6iWVH");


var $lFQjm = parcelRequire("lFQjm");


var $7HZZ5 = parcelRequire("7HZZ5");


var $en9ZE = parcelRequire("en9ZE");

const $ae28fc22beba689b$export$2f76bd244cc53ebd = new Set([
    (0, $en9ZE.default).jiraBacklogPrompt3,
    (0, $en9ZE.default).jiraBacklogPrompt7
]);
const $ae28fc22beba689b$export$c6a4ebf596b0c08a = {
    [(0, $6iWVH.PageContextType).BITBUCKET_CREATE_PULL_REQUEST]: [
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketCreatePullRequestsPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_PULL_REQUEST]: [
        {
            labelType: 'summarize-information',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt1
        },
        {
            labelType: 'summarize-code',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt4
        },
        {
            labelType: 'analyze-content',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt5
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketPullRequestsPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_REPOSITORY_SOURCE]: [
        {
            labelType: 'summarize-code',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt4
        },
        {
            labelType: 'code-search',
            message: (0, $en9ZE.default).bitbucketRepositorySourcePrompt5
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET_PIPELINES]: [
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).bitbucketPipelinePrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).BITBUCKET]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).bitbucketPrompt5
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).bitbucketPrompt6
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).bitbucketPrompt7
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_HOME]: [
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluenceHomePrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluenceHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluenceHomePrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluenceHomePrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt9
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt10
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt11
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageViewPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageViewPrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_WHITEBOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceWhiteboardPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageEditPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluencePageEditPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY]: [],
    [(0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY]: [],
    [(0, $6iWVH.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS]: [],
    [(0, $6iWVH.PageContextType).JIRA_HOME]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraHomePrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraHomePrompt4
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraHomePrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraHomePrompt6
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_FOR_YOU]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).unknownPrompt3
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).jiraForYouPrompt1
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraForYouPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraForYouPrompt3
        },
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).jiraForYouPrompt4
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraForYouPrompt5
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraForYouPrompt6
        },
        {
            labelType: 'summarize-information',
            message: (0, $en9ZE.default).jiraForYouPrompt7
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraIssueViewPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).jiraIssueViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraIssueViewPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraIssueViewPrompt4
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_PROJECT]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraProjectPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt2
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraProjectPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt4
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt6
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraProjectPrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraProjectPrompt8
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraProjectPrompt9
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraProjectPrompt10
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).jiraProjectPrompt11
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraProjectPrompt12
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraProjectPrompt13
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraProjectPrompt14
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_BOARD]: [
        {
            labelType: 'automation-rule',
            message: (0, $en9ZE.default).jiraBoardPrompt1
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraBoardPrompt3
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraBoardPrompt4
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).jiraBoardPrompt5
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraBoardPrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraBoardPrompt7
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraBoardPrompt8
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraBoardPrompt9
        },
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).jiraBoardPrompt10
        }
    ],
    [(0, $6iWVH.PageContextType).JIRA_BACKLOG]: [
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jiraBacklogPrompt1
        },
        {
            labelType: 'check-status',
            message: (0, $en9ZE.default).jiraBacklogPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).jiraBacklogPrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jiraBacklogPrompt4
        },
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).jiraBacklogPrompt7
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).jiraBacklogPrompt8
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraBacklogPrompt9
        },
        {
            labelType: 'analyze-content',
            message: (0, $en9ZE.default).jiraBacklogPrompt10
        },
        {
            labelType: 'automation-rule',
            message: (0, $en9ZE.default).jiraBacklogPrompt11
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jiraBacklogPrompt12
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraBacklogPrompt13
        },
        {
            labelType: 'summarize-information',
            message: (0, $en9ZE.default).jiraBacklogPrompt14
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).jiraBacklogPrompt15
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_INCIDENT_VIEW]: [
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).jsmIncidentViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_INCIDENT_LIST_VIEW]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmIncidentListViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_LIST_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertListViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt2
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jsmAlertGroupDetailViewPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).ATLAS_HOME]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).atlasHomePrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).atlasHomePrompt2
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).atlasHomePrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).atlasHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).atlasHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).atlasHomePrompt6
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluenceHomePrompt5
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt11
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt10
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).atlasHomePrompt7
        }
    ],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_MAIN]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).atlasHomePrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).atlasHomePrompt2
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).atlasHomePrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).atlasHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).atlasHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).atlasHomePrompt6
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).confluenceHomePrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).confluenceHomePrompt5
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).confluenceHomePrompt11
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $en9ZE.default).confluenceHomePrompt10
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $en9ZE.default).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).jiraHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).atlasHomePrompt7
        }
    ],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_DISCOVER]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_RECENTS]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST]: [],
    [(0, $6iWVH.PageContextType).FOCUS]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusPrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $en9ZE.default).focusPrompt2
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOR_YOU]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusForYouPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_PAGE]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaGoalPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaWorkPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_FUNDS_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).focusAreaPrompt1
        },
        {
            labelType: 'analyze-content',
            message: (0, $en9ZE.default).focusAreaFundsPrompt1
        }
    ],
    [(0, $6iWVH.PageContextType).SAC]: [
        {
            labelType: 'manage-settings',
            message: (0, $en9ZE.default).sacPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).sacPrompt2
        },
        {
            labelType: 'automation-rule',
            message: (0, $en9ZE.default).sacPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).TRELLO_BOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).trelloBoardPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).trelloBoardPrompt2
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).trelloBoardPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).TRELLO_CARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $en9ZE.default).trelloCardPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).trelloCardPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $en9ZE.default).trelloCardPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).UNKNOWN]: [
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $en9ZE.default).unknownPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).STUDIO_AGENT_BUILDER]: [
        {
            labelType: 'be-productive',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $en9ZE.default).studioAgentBuilderPrompt3
        }
    ],
    [(0, $6iWVH.PageContextType).ADMIN_HUB]: []
};
const $ae28fc22beba689b$export$a905239756c1fbae = (location)=>{
    const jsmIncidentViewPatterns = [
        // Single incident view (with issue key at the end)
        [
            (0, $6iWVH.PageContextType).JSM_INCIDENT_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+\/[A-Z]+-\d+/
        ]
    ];
    const jsmOpsPatterns = (0, $iDrrr.fg)('rovo_ops_conversation_starters_enabled') ? [
        // Incident list view (without issue key at the end)
        [
            (0, $6iWVH.PageContextType).JSM_INCIDENT_LIST_VIEW,
            /\/jira\/servicedesk\/projects\/[^\/]+\/section\/incidents\/custom\/\d+$/
        ],
        // Single alert view (has / after alerts)
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_VIEW,
            /\/jira\/ops\/alerts\//
        ],
        // Alert list view (has ? after alerts)
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_LIST_VIEW,
            /\/jira\/ops\/alerts\?/
        ],
        // Alert group detail view
        [
            (0, $6iWVH.PageContextType).JSM_ALERT_GROUP_DETAIL_VIEW,
            /\/jira\/ops\/group-detail\//
        ]
    ] : [];
    const jiraBoardPattern = /\/jira\/.+\/projects\/[^\/]+\/boards\/[^\/?#]+\/?(?:[?#].*)?$/;
    // Jira board contextual starters are gated by a targeting feature gate plus an experiment.
    // Unlike most patterns below, we test the board route before adding it to urlPatterns so
    // getExperimentValue is only read on board pages and non-board pages do not log exposures.
    const jiraBoardPatterns = [];
    if (jiraBoardPattern.test(location) && (0, $iDrrr.fg)('jira_boards_rovo_contextual_actions_experiment_eligibility')) {
        const actionsVariant = (0, $cXtTj.default).getExperimentValue('jira_boards_rovo_actions_exp_targeted', 'actions_variant', 'control_static_actions');
        if (actionsVariant === 'contextual_actions_only') jiraBoardPatterns.push([
            (0, $6iWVH.PageContextType).JIRA_BOARD,
            jiraBoardPattern
        ]);
    }
    // Test the backlog route before reading the experiment so `getExperimentValue` is only
    // called on backlog pages and non-backlog pages do not log exposures.
    const jiraBacklogPattern = /\/jira\/.+\/projects\/[^\/]+\/boards\/[^\/]+\/backlog/;
    const jiraBacklogPatterns = [];
    if (jiraBacklogPattern.test(location) && (0, $cXtTj.default).getExperimentValue('jira_backlog_rovo_contextual_starters_experiment', 'isEnabled', false)) jiraBacklogPatterns.push([
        (0, $6iWVH.PageContextType).JIRA_BACKLOG,
        jiraBacklogPattern
    ]);
    const jiraForYouPattern = /\/jira\/for-you(?:[?#\/]|$)/;
    const jiraForYouPatterns = [];
    if (jiraForYouPattern.test(location) && (0, $cXtTj.default).getExperimentValue('jira_for_you_rovo_contextual_starters_experiment', 'isEnabled', false)) jiraForYouPatterns.push([
        (0, $6iWVH.PageContextType).JIRA_FOR_YOU,
        jiraForYouPattern
    ]);
    // Builder starters show only on an agent page reached via "Customize a template", marked by the
    // `fromTemplate=true` param Studio stamps on the URL. Matched on path and param rather than host,
    // because Studio is served from several hosts (`studio.*`, `atlassian-studio.*` frontend deploys,
    // `localhost`) and `fromTemplate` on an agents path is Studio's alone. Tested before `fg` so
    // exposure stays on these pages.
    const studioAgentBuilderFromTemplatePattern = /\/agents\/[^#]*[?&]fromTemplate=true(?:&|#|$)/;
    const studioAgentBuilderPatterns = studioAgentBuilderFromTemplatePattern.test(location) && (0, $iDrrr.fg)('sgrow-149-open-rovo-after-customize') ? [
        [
            (0, $6iWVH.PageContextType).STUDIO_AGENT_BUILDER,
            studioAgentBuilderFromTemplatePattern
        ]
    ] : [];
    const urlPatterns = [
        ...studioAgentBuilderPatterns,
        [
            (0, $6iWVH.PageContextType).BITBUCKET_REPOSITORY_SOURCE,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/src\//
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/\d+/
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_CREATE_PULL_REQUEST,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\/new/
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET_PIPELINES,
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pipelines\/results\/[^\/]+\/steps\//
        ],
        [
            (0, $6iWVH.PageContextType).BITBUCKET,
            /bitbucket\.org\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/?$/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_HOME,
            /\/wiki\/home$/
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_EDIT,
            /\/wiki\/spaces\/[^\/]+\/blog\/edit-v2\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_BLOG_VIEW,
            /\/wiki\/spaces\/[^\/]+\/blog\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_EDIT,
            /\/wiki\/spaces\/[^\/]+\/pages\/edit-v2\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_PAGE_VIEW,
            /\/wiki\/spaces\/[^\/]+\/pages\//
        ],
        [
            (0, $6iWVH.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW,
            /\/browse\/[^\/]+$/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_ISSUE_VIEW,
            /\/jira\/.+\/projects\/[^/]+\/[^?]+\?(?:.*&)?selectedIssue=/
        ],
        ...jsmIncidentViewPatterns,
        ...jsmOpsPatterns,
        [
            (0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_TMP_SPACE_SETTINGS_ACCESS,
            /\/jira\/software\/projects\/[^\/]+\/settings\/access/
        ],
        // Order matters: backlog must be tested before board because backlog URLs are a superset
        // of board URLs (they both start with `/projects/<key>/boards/<id>`), and the first match wins.
        ...jiraBacklogPatterns,
        ...jiraBoardPatterns,
        [
            (0, $6iWVH.PageContextType).JIRA_PROJECT,
            /\/jira\/.+\/projects\//
        ],
        [
            (0, $6iWVH.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        ...jiraForYouPatterns,
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_DISCOVER,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*discover+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_RECENTS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*recents+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_FULL_PAGE_NOTIFICATIONS,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*notifications+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_PROJECT_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/projects+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_GOAL_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/goals+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_TEAM_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/team+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_TAG_UPDATES_LIST,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*updates\/tag+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME_MAIN,
            /(home|team)\..*\.com\/(?:[^\/]+\/)*\?cloudId=[^\/]+/
        ],
        [
            (0, $6iWVH.PageContextType).ATLAS_HOME,
            /\/(home|team)\./
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_GOAL_VIEW,
            /\/focus\/focus-area\/.*\/goals/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_WORK_VIEW,
            /\/focus\/focus-area\/.*\/work/
        ],
        ...(0, $iDrrr.fg)('rovo_chat_focus_analyze_funds') ? [
            [
                (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_FUNDS_VIEW,
                /\/focus\/focus-area\/.*\/funds/
            ]
        ] : [],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOCUS_AREA_PAGE,
            /\/focus\/focus-area\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS_FOR_YOU,
            /\/focus\/for-you(?:\/.*)?$/
        ],
        [
            (0, $6iWVH.PageContextType).FOCUS,
            /\/focus\/.*/
        ],
        [
            (0, $6iWVH.PageContextType).SAC,
            /support\.atlassian\.com/
        ],
        // Trello: card view first (more specific), then board. Prod: trello.com, Staging: trellis.coffee (and *.atlassian.com)
        [
            (0, $6iWVH.PageContextType).TRELLO_CARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/c\//
        ],
        [
            (0, $6iWVH.PageContextType).TRELLO_BOARD,
            /(?:trello\.com|trellis\.coffee|[\w-]*trello[\w-]*\.(?:stg\.)?atlassian\.com)\/b\//
        ],
        // admin hub: admin.atlassian.com (production) or admin.stg.atlassian.com (staging)
        [
            (0, $6iWVH.PageContextType).ADMIN_HUB,
            /admin(\.stg)?\.atlassian\.com/
        ]
    ];
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return (0, $6iWVH.PageContextType).UNKNOWN;
};
const $ae28fc22beba689b$export$bc4bf2ff8e40b690 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const location = (0, $lFQjm.useWindowLocation)();
    let t0;
    if ($[0] !== location) {
        t0 = $ae28fc22beba689b$export$a905239756c1fbae(location);
        $[0] = location;
        $[1] = t0;
    } else t0 = $[1];
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[2] !== location) {
        t1 = ()=>{
            setPageContextType($ae28fc22beba689b$export$a905239756c1fbae(location));
        };
        t2 = [
            location
        ];
        $[2] = location;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return pageContextType;
} : ()=>{
    const location = (0, $lFQjm.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)($ae28fc22beba689b$export$a905239756c1fbae(location));
    (0, $cozmU.useEffect)(()=>{
        setPageContextType($ae28fc22beba689b$export$a905239756c1fbae(location));
    }, [
        location
    ]);
    return pageContextType;
};
const $ae28fc22beba689b$var$shuffleStarters = (arr)=>{
    const copiedArr = [
        ...arr
    ];
    // Shuffle array using Fisher-Yates algorithm
    for(let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [copiedArr[i], copiedArr[j]] = [
            copiedArr[j],
            copiedArr[i]
        ];
    }
    return copiedArr;
};
const $ae28fc22beba689b$export$82bea1a28fda43c1 = (starters, num)=>{
    // Return the first `num` items
    return $ae28fc22beba689b$var$shuffleStarters(starters).slice(0, num);
};
const $ae28fc22beba689b$var$getIconAndLabelForStarter = (labelType)=>{
    switch(labelType){
        case 'be-productive':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).beProductiveLabel
            };
        case 'stay-up-to-date':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).stayUpToDateLabel
            };
        case 'summarize-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeContentLabel
            };
        case 'rephrase-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).rephraseContentLabel
            };
        case 'draft-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aooxV))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).draftContentLabel
            };
        case 'find-information':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).findInformationLabel
            };
        case 'find-people':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).findPeopleLabel
            };
        case 'code-search':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).codeSearchLabel
            };
        case 'measure-productivity':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).measureProductivityLabel
            };
        case 'get-answers':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).getAnswersLabel
            };
        case 'check-status':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5n93X))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).checkStatusLabel
            };
        case 'summarize-information':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeInformationLabel
            };
        case 'analyze-content':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).analyzeContentLabel
            };
        case 'summarize-code':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXXTm))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).summarizeCodeLabel
            };
        case 'manage-settings':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4s4Os))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).manageSettingsLabel
            };
        case 'automation-rule':
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($11OF7))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).automationRuleLabel
            };
        default:
            return {
                icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
                    label: ""
                }),
                label: (0, $en9ZE.default).beProductiveLabel
            };
    }
};
// default to fetching 3 dynamic starters
const $ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT = 3;
const $ae28fc22beba689b$export$65b45f3b39cd6930 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageContextType = $ae28fc22beba689b$export$bc4bf2ff8e40b690();
    const location = (0, $lFQjm.useWindowLocation)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const t1 = dynamicStartersConfig?.enabled && !!assistanceServiceParams;
    let t2;
    if ($[0] !== assistanceServiceParams) {
        t2 = assistanceServiceParams || {
            touchpointSource: "",
            product: "",
            experienceId: "",
            siteId: ""
        };
        $[0] = assistanceServiceParams;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== location || $[3] !== pageContextType || $[4] !== t1 || $[5] !== t2) {
        t3 = {
            contentUrl: location,
            pageContextType: pageContextType,
            showConvoStarters: t1,
            assistanceServiceParams: t2
        };
        $[2] = location;
        $[3] = pageContextType;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $7HZZ5.useFetchConvoStarters)(t3);
    let t4;
    bb0: {
        if (pageContextType !== (0, $6iWVH.PageContextType).JIRA_BACKLOG) {
            t4 = false;
            break bb0;
        }
        const jiraViewContext = aiFeatureContext?.jira_view_context;
        t4 = jiraViewContext?.isSprintEnabled === false;
    }
    const isBacklogSprintDisabled = t4;
    let t5;
    if ($[7] !== formatMessage || $[8] !== isBacklogSprintDisabled || $[9] !== pageContextType) {
        let t6;
        if ($[11] !== isBacklogSprintDisabled) {
            t6 = (starter)=>isBacklogSprintDisabled ? !$ae28fc22beba689b$export$2f76bd244cc53ebd.has(starter.message) : true;
            $[11] = isBacklogSprintDisabled;
            $[12] = t6;
        } else t6 = $[12];
        const rawStarters = $ae28fc22beba689b$export$c6a4ebf596b0c08a[pageContextType].filter(t6);
        let t7;
        if ($[13] !== formatMessage) {
            t7 = (starter_0)=>{
                const shouldShowBetaBadge = starter_0.message === (0, $en9ZE.default).focusAreaFundsPrompt1;
                return {
                    labelType: starter_0.labelType,
                    message: formatMessage(starter_0.message),
                    badge: shouldShowBetaBadge ? /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
                        appearance: "discovery"
                    }, formatMessage((0, $en9ZE.default).focusAreaFundsBetaBadge)) : undefined,
                    type: "static"
                };
            };
            $[13] = formatMessage;
            $[14] = t7;
        } else t7 = $[14];
        t5 = rawStarters.map(t7);
        $[7] = formatMessage;
        $[8] = isBacklogSprintDisabled;
        $[9] = pageContextType;
        $[10] = t5;
    } else t5 = $[10];
    const contextualStarters = t5;
    const staticStarters = contextualStarters;
    let t6;
    if ($[15] !== staticStarters) {
        t6 = staticStarters.reduce($ae28fc22beba689b$var$_temp, {});
        $[15] = staticStarters;
        $[16] = t6;
    } else t6 = $[16];
    const groupedStarters = t6;
    let t7;
    if ($[17] !== groupedStarters) {
        t7 = Object.entries(groupedStarters).map($ae28fc22beba689b$var$_temp6);
        $[17] = groupedStarters;
        $[18] = t7;
    } else t7 = $[18];
    const conversationStarterActions = t7;
    let t8;
    if ($[19] !== formatMessage || $[20] !== groupedStarters) {
        t8 = Object.entries(groupedStarters).map((t9)=>{
            const [, starters_0] = t9;
            const { icon: icon, label: label } = $ae28fc22beba689b$var$getIconAndLabelForStarter(starters_0[0].labelType);
            return {
                id: "convo-starter",
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: $ae28fc22beba689b$var$_temp7,
                badge: starters_0.find($ae28fc22beba689b$var$_temp8)?.badge,
                children: starters_0.map((starter_4)=>{
                    const starterHasPlaceholder_0 = starter_4.message.includes("`");
                    return {
                        id: "convo-starter",
                        title: starter_4.message,
                        icon: ()=>icon,
                        onClick: $ae28fc22beba689b$var$_temp9,
                        type: "convo-starter-action",
                        handleType: (0, $6iWVH.HandleActionType).Chat,
                        ...starterHasPlaceholder_0 ? {
                            dynamicPrompt: starter_4.message
                        } : {
                            staticPrompt: starter_4.message
                        },
                        badge: starter_4.badge,
                        starterType: "static"
                    };
                }),
                handleType: (0, $6iWVH.HandleActionType).Nested,
                type: "convo-starter-action"
            };
        });
        $[19] = formatMessage;
        $[20] = groupedStarters;
        $[21] = t8;
    } else t8 = $[21];
    const nestedConversationStarterActions = t8;
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    dynamicStartersConfig?.enabled;
    let t9;
    bb1: {
        if (!dynamicStartersConfig?.enabled) {
            let t10;
            if ($[22] !== conversationStarterActions || $[23] !== numStartersToReturn) {
                t10 = $ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
                $[22] = conversationStarterActions;
                $[23] = numStartersToReturn;
                $[24] = t10;
            } else t10 = $[24];
            t9 = t10;
            break bb1;
        }
        if (isDynamicStarterActionsLoading) {
            let t10;
            if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
                t10 = [];
                $[25] = t10;
            } else t10 = $[25];
            t9 = t10;
            break bb1;
        }
        if (dynamicStarterActions.length >= numStartersToReturn) {
            let t10;
            if ($[26] !== dynamicStarterActions || $[27] !== numStartersToReturn) {
                t10 = dynamicStarterActions.slice(0, numStartersToReturn);
                $[26] = dynamicStarterActions;
                $[27] = numStartersToReturn;
                $[28] = t10;
            } else t10 = $[28];
            t9 = t10;
            break bb1;
        }
        let t10;
        if ($[29] !== conversationStarterActions || $[30] !== dynamicStarterActions || $[31] !== numStartersToReturn) {
            t10 = [
                ...dynamicStarterActions,
                ...$ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
            ];
            $[29] = conversationStarterActions;
            $[30] = dynamicStarterActions;
            $[31] = numStartersToReturn;
            $[32] = t10;
        } else t10 = $[32];
        t9 = t10;
    }
    const randomizedConversationStarterActions = t9;
    let t10;
    if ($[33] !== nestedConversationStarterActions || $[34] !== numNestedStartersToReturn) {
        t10 = $ae28fc22beba689b$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
        $[33] = nestedConversationStarterActions;
        $[34] = numNestedStartersToReturn;
        $[35] = t10;
    } else t10 = $[35];
    const randomizedNestedConversationStarterActions = t10;
    const t11 = Math.min($ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn);
    let t12;
    if ($[36] !== isDynamicStarterActionsLoading || $[37] !== randomizedConversationStarterActions || $[38] !== randomizedNestedConversationStarterActions || $[39] !== t11) {
        t12 = {
            conversationStarterActions: randomizedConversationStarterActions,
            nestedConversationStarterActions: randomizedNestedConversationStarterActions,
            getRandomStarters: $ae28fc22beba689b$export$82bea1a28fda43c1,
            isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
            numDynamicStarterActionsLoading: t11
        };
        $[36] = isDynamicStarterActionsLoading;
        $[37] = randomizedConversationStarterActions;
        $[38] = randomizedNestedConversationStarterActions;
        $[39] = t11;
        $[40] = t12;
    } else t12 = $[40];
    return t12;
} : ({ numStarters: numStarters, dynamicStartersConfig: dynamicStartersConfig, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageContextType = $ae28fc22beba689b$export$bc4bf2ff8e40b690();
    const location = (0, $lFQjm.useWindowLocation)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const { convoStarters: dynamicStarterActions, isLoading: isDynamicStarterActionsLoading } = (0, $7HZZ5.useFetchConvoStarters)({
        contentUrl: location,
        pageContextType: pageContextType,
        showConvoStarters: dynamicStartersConfig?.enabled && !!assistanceServiceParams,
        // hacky workaround for consumers that don't need dynamic starters (and therfore don't pass in assistanceServiceParams)
        assistanceServiceParams: assistanceServiceParams || {
            touchpointSource: '',
            product: '',
            experienceId: '',
            siteId: ''
        }
    });
    const isBacklogSprintDisabled = (0, $cozmU.useMemo)(()=>{
        if (pageContextType !== (0, $6iWVH.PageContextType).JIRA_BACKLOG) return false;
        const jiraViewContext = aiFeatureContext?.jira_view_context;
        return jiraViewContext?.isSprintEnabled === false;
    }, [
        pageContextType,
        aiFeatureContext
    ]);
    const staticStarters = (0, $cozmU.useMemo)(()=>{
        const rawStarters = $ae28fc22beba689b$export$c6a4ebf596b0c08a[pageContextType].filter((starter)=>isBacklogSprintDisabled ? !$ae28fc22beba689b$export$2f76bd244cc53ebd.has(starter.message) : true);
        const contextualStarters = rawStarters.map((starter_0)=>{
            const shouldShowBetaBadge = starter_0.message === (0, $en9ZE.default).focusAreaFundsPrompt1;
            return {
                labelType: starter_0.labelType,
                message: formatMessage(starter_0.message),
                badge: shouldShowBetaBadge ? /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
                    appearance: "discovery"
                }, formatMessage((0, $en9ZE.default).focusAreaFundsBetaBadge)) : undefined,
                type: 'static'
            };
        });
        return contextualStarters;
    }, [
        pageContextType,
        formatMessage,
        isBacklogSprintDisabled
    ]);
    const groupedStarters = (0, $cozmU.useMemo)(()=>staticStarters.reduce((acc, starter_1)=>{
            if (!starter_1.labelType) return acc;
            acc[starter_1.labelType] = [
                ...acc[starter_1.labelType] || [],
                starter_1
            ];
            return acc;
        }, {}), [
        staticStarters
    ]);
    // Use this to get conversation starter actions that are not nested (e.g. for Sidebar)
    const conversationStarterActions = (0, $cozmU.useMemo)(()=>Object.entries(groupedStarters).map(([, starters])=>{
            // If there is only one starter in the group, return as a single chat action, otherwise return one of the nested items to use as a starter
            if (starters.length === 1) {
                const starter_2 = starters[0];
                const starterHasPlaceholder = starter_2.message.includes('`');
                return {
                    id: 'convo-starter',
                    title: starter_2.message,
                    icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $6iWVH.HandleActionType).Chat,
                    children: [],
                    ...starterHasPlaceholder ? {
                        dynamicPrompt: starter_2.message
                    } : {
                        staticPrompt: starter_2.message
                    },
                    badge: starter_2.badge,
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            } else {
                //Grab a random starter from the group to use
                const randomIndex = Math.floor(Math.random() * starters.length);
                const randomStarter = starters[randomIndex];
                const randomStarterHasPlaceholder = randomStarter.message.includes('`');
                return {
                    id: `convo-starter`,
                    title: randomStarter.message,
                    icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                            label: ""
                        }),
                    onClick: ()=>{},
                    handleType: (0, $6iWVH.HandleActionType).Chat,
                    ...randomStarterHasPlaceholder ? {
                        dynamicPrompt: randomStarter.message
                    } : {
                        staticPrompt: randomStarter.message
                    },
                    badge: randomStarter.badge,
                    type: 'convo-starter-action',
                    starterType: 'static'
                };
            }
        }), [
        groupedStarters
    ]);
    // Use this to get conversation starter actions that are nested (e.g. for Full Screen)
    const nestedConversationStarterActions = (0, $cozmU.useMemo)(()=>Object.entries(groupedStarters).map(([, starters_0])=>{
            const { icon: icon, label: label } = $ae28fc22beba689b$var$getIconAndLabelForStarter(starters_0[0].labelType);
            return {
                id: 'convo-starter',
                title: formatMessage(label),
                icon: ()=>icon,
                onClick: ()=>{},
                badge: starters_0.find((starter_3)=>starter_3.badge)?.badge,
                children: starters_0.map((starter_4)=>{
                    const starterHasPlaceholder_0 = starter_4.message.includes('`');
                    return {
                        id: 'convo-starter',
                        title: starter_4.message,
                        icon: ()=>icon,
                        onClick: ()=>{},
                        type: 'convo-starter-action',
                        handleType: (0, $6iWVH.HandleActionType).Chat,
                        ...starterHasPlaceholder_0 ? {
                            dynamicPrompt: starter_4.message
                        } : {
                            staticPrompt: starter_4.message
                        },
                        badge: starter_4.badge,
                        starterType: 'static'
                    };
                }),
                handleType: (0, $6iWVH.HandleActionType).Nested,
                type: 'convo-starter-action'
            };
        }), [
        groupedStarters,
        formatMessage
    ]);
    const numStartersToReturn = numStarters ?? conversationStarterActions.length + dynamicStarterActions.length;
    // dynamic starter actions are not included in nested use case
    const numNestedStartersToReturn = numStarters ?? nestedConversationStarterActions.length;
    const randomizedConversationStarterActions = (0, $cozmU.useMemo)(()=>{
        if (!dynamicStartersConfig?.enabled) return $ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn);
        if (isDynamicStarterActionsLoading) return [];
        if (dynamicStarterActions.length >= numStartersToReturn) return dynamicStarterActions.slice(0, numStartersToReturn);
        // prioritizes dynamic starters, and then randomizes the static starters
        return [
            ...dynamicStarterActions,
            ...$ae28fc22beba689b$export$82bea1a28fda43c1(conversationStarterActions, numStartersToReturn - dynamicStarterActions.length)
        ];
    }, [
        conversationStarterActions,
        numStartersToReturn,
        dynamicStarterActions,
        isDynamicStarterActionsLoading,
        dynamicStartersConfig?.enabled
    ]);
    const randomizedNestedConversationStarterActions = (0, $cozmU.useMemo)(()=>{
        return $ae28fc22beba689b$export$82bea1a28fda43c1(nestedConversationStarterActions, numNestedStartersToReturn);
    }, [
        nestedConversationStarterActions,
        numNestedStartersToReturn
    ]);
    return {
        conversationStarterActions: randomizedConversationStarterActions,
        nestedConversationStarterActions: randomizedNestedConversationStarterActions,
        getRandomStarters: $ae28fc22beba689b$export$82bea1a28fda43c1,
        isDynamicStarterActionsLoading: isDynamicStarterActionsLoading,
        numDynamicStarterActionsLoading: Math.min($ae28fc22beba689b$var$DYNAMIC_STARTERS_COUNT, numStartersToReturn)
    };
};
function $ae28fc22beba689b$var$_temp(acc, starter_1) {
    if (!starter_1.labelType) return acc;
    acc[starter_1.labelType] = [
        ...acc[starter_1.labelType] || [],
        starter_1
    ];
    return acc;
}
function $ae28fc22beba689b$var$_temp2() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        label: ""
    });
}
function $ae28fc22beba689b$var$_temp3() {}
function $ae28fc22beba689b$var$_temp4() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        label: ""
    });
}
function $ae28fc22beba689b$var$_temp5() {}
function $ae28fc22beba689b$var$_temp6(t0) {
    const [, starters] = t0;
    if (starters.length === 1) {
        const starter_2 = starters[0];
        const starterHasPlaceholder = starter_2.message.includes("`");
        return {
            id: "convo-starter",
            title: starter_2.message,
            icon: $ae28fc22beba689b$var$_temp2,
            onClick: $ae28fc22beba689b$var$_temp3,
            handleType: (0, $6iWVH.HandleActionType).Chat,
            children: [],
            ...starterHasPlaceholder ? {
                dynamicPrompt: starter_2.message
            } : {
                staticPrompt: starter_2.message
            },
            badge: starter_2.badge,
            type: "convo-starter-action",
            starterType: "static"
        };
    } else {
        const randomIndex = Math.floor(Math.random() * starters.length);
        const randomStarter = starters[randomIndex];
        const randomStarterHasPlaceholder = randomStarter.message.includes("`");
        return {
            id: "convo-starter",
            title: randomStarter.message,
            icon: $ae28fc22beba689b$var$_temp4,
            onClick: $ae28fc22beba689b$var$_temp5,
            handleType: (0, $6iWVH.HandleActionType).Chat,
            ...randomStarterHasPlaceholder ? {
                dynamicPrompt: randomStarter.message
            } : {
                staticPrompt: randomStarter.message
            },
            badge: randomStarter.badge,
            type: "convo-starter-action",
            starterType: "static"
        };
    }
}
function $ae28fc22beba689b$var$_temp7() {}
function $ae28fc22beba689b$var$_temp8(starter_3) {
    return starter_3.badge;
}
function $ae28fc22beba689b$var$_temp9() {}
module.exports["usePageContextType"] = $ae28fc22beba689b$export$bc4bf2ff8e40b690;
module.exports["useRovoConversationStarters"] = $ae28fc22beba689b$export$65b45f3b39cd6930;

});

parcelRegister("7HZZ5", function(module, exports) {
// adapted from: platform/packages/insights-ai-platform/ai-smart-button/src/ui/ai-actions/hooks/useFetchConvoStarters.ts

var $cozmU = parcelRequire("cozmU");


var $mfdwv = parcelRequire("mfdwv");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $6iWVH = parcelRequire("6iWVH");


var $5uiWK = parcelRequire("5uiWK");


var $bQmvI = parcelRequire("bQmvI");

const $534dbfa9546a4c22$var$mapToConversationActionNew = (starterObject)=>{
    return {
        id: 'convo-starter',
        title: starterObject.starter,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
                label: ""
            }),
        staticPrompt: starterObject.starter,
        handleType: (0, $6iWVH.HandleActionType).Chat,
        starterType: 'dynamic',
        jtbdCategory: starterObject.jtbd_category,
        agent: undefined,
        type: 'convo-starter-action'
    };
};
const $534dbfa9546a4c22$export$460b2fd9dae847fd = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId }, contentUrl: contentUrl, pageContextType: pageContextType, showConvoStarters: showConvoStarters = false })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const timingRef = (0, $cozmU.useRef)(null);
    const contentAri = (0, $cozmU.useMemo)(()=>(0, $bQmvI.getContentAri)(siteId, contentUrl, pageContextType), [
        siteId,
        contentUrl,
        pageContextType
    ]);
    // TODO ASIMO-2398: experiment cleanup
    const urlDebugInfo = (0, $cozmU.useMemo)(()=>{
        try {
            const url = new URL(contentUrl);
            return {
                pathSegmentCount: url.pathname.split('/').filter(Boolean).length,
                hasQueryParams: url.search.length > 0,
                protocol: url.protocol
            };
        } catch  {
            return {
                pathSegmentCount: 0,
                hasQueryParams: false,
                protocol: 'invalid'
            };
        }
    }, [
        contentUrl
    ]);
    const isPageContextTypeSupported = (0, $5uiWK.isPageContextTypeSupportedForDynamicStarters)(pageContextType);
    const isEligibleContext = isPageContextTypeSupported && contentAri !== null;
    const isFeatureEnabled = showConvoStarters && isEligibleContext;
    // TODO ASIMO-2398: experiment cleanup
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'called',
            actionSubject: 'useFetchConvoStarters',
            attributes: {
                showConvoStarters: showConvoStarters,
                isPageContextTypeSupported: isPageContextTypeSupported,
                isEligibleContext: isEligibleContext,
                isFeatureEnabled: isFeatureEnabled,
                pageContextType: String(pageContextType),
                hasContentAri: contentAri !== null,
                contentAri: contentAri,
                urlStructure: urlDebugInfo
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { data: convoStarters, isFetching: isLoading, error: fetchError } = (0, $5SS4O.useQuery)({
        enabled: isFeatureEnabled,
        queryKey: [
            'dynamicConvoStarters',
            contentAri ?? contentUrl
        ],
        queryFn: async ()=>{
            // Custom performance tracking for dynamic starters experiment to analyze on Statsig.
            // Confluence ui taskSuccess events aren't sent to Statsig.
            timingRef.current = {
                startTime: performance.now(),
                sent: false,
                pageContextType: String(pageContextType)
            };
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'started',
                actionSubject: 'fetchConvoStarters',
                attributes: {
                    pageContextType: timingRef.current.pageContextType
                }
            });
            const response = await assistanceService.getDynamicConvoStartersNew({
                ai_feature_input: {
                    // safe to assert: query is disabled (enabled condition) when contentAri is null
                    documents: [
                        {
                            ari: contentAri
                        }
                    ]
                }
            });
            // Since we only request one document, we should get exactly one result
            const result = response?.ai_feature_output?.results?.[0];
            if (!result) throw new Error('Expected one result in API response but received none');
            if (result.error) {
                const errorType = result.error.error_type;
                // expected failures (HYDRATION_ERROR) are silently filtered
                if (errorType === 'HYDRATION_ERROR') return [];
                throw new Error(`[${errorType}] ${result.error.message}`);
            }
            if (!result.convo_starters.length) return [];
            return result.convo_starters.map((starter)=>$534dbfa9546a4c22$var$mapToConversationActionNew(starter));
        },
        onSuccess: (data)=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS
            });
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'succeeded',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        startersCount: data?.length ?? 0,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        },
        onError: (error)=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'failed',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        errorMessage: error.message,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_DYNAMIC_CONVERSATION_STARTERS,
                error: error
            });
        }
    });
    // Track cancellations when component unmounts during fetch
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timingRef.current && !timingRef.current.sent) {
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'cancelled',
                    actionSubject: 'fetchConvoStarters',
                    attributes: {
                        duration: performance.now() - timingRef.current.startTime,
                        pageContextType: timingRef.current.pageContextType
                    }
                });
                timingRef.current.sent = true;
            }
        };
    }, [
        sendAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            convoStarters: convoStarters ?? [],
            isLoading: isLoading,
            error: fetchError ?? undefined
        }), [
        convoStarters,
        isLoading,
        fetchError
    ]);
});
module.exports["useFetchConvoStarters"] = $534dbfa9546a4c22$export$460b2fd9dae847fd;

});

parcelRegister("en9ZE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b0ccb00ee4479897$var$_default_1 = (0, $kSwu1.defineMessages)({
    // Conversation starter labels
    beProductiveLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.be-productive",
        defaultMessage: "Be productive"
    },
    stayUpToDateLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.stay-up-to-date",
        defaultMessage: "Stay up-to-date"
    },
    summarizeContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-content",
        defaultMessage: "Summarize content"
    },
    rephraseContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.rephrase-content",
        defaultMessage: "Rephrase content"
    },
    draftContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.draft-content",
        defaultMessage: "Draft content"
    },
    findInformationLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.find-information",
        defaultMessage: "Find information"
    },
    findPeopleLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.find-people",
        defaultMessage: "Find people"
    },
    codeSearchLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.code-search",
        defaultMessage: "Code search"
    },
    measureProductivityLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.measure-productivity",
        defaultMessage: "Measure productivity"
    },
    getAnswersLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.get-answers",
        defaultMessage: "Get answers"
    },
    checkStatusLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.check-status",
        defaultMessage: "Check status"
    },
    summarizeInformationLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-information",
        defaultMessage: "Summarize information"
    },
    analyzeContentLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.analyze-content",
        defaultMessage: "Analyze content"
    },
    summarizeCodeLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.summarize-code",
        defaultMessage: "Summarize code"
    },
    automationRuleLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.automation-rule",
        defaultMessage: "Automation rule"
    },
    manageSettingsLabel: {
        id: "rovo-conversation-actions.conversation-starters.label.manage-settings",
        defaultMessage: "Manage settings"
    },
    // BITBUCKET_CREATE_PULL_REQUESTS
    bitbucketCreatePullRequestsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-create-pull-requests.starter-1",
        defaultMessage: "Suggest reviewers for this pull request"
    },
    // BITBUCKET_PULL_REQUESTS
    bitbucketPullRequestsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-1",
        defaultMessage: "Summarize this pull request"
    },
    bitbucketPullRequestsPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-2",
        defaultMessage: "Explain the code changes to me."
    },
    bitbucketPullRequestsPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-3",
        defaultMessage: "Summarize the comments on this pull request"
    },
    bitbucketPullRequestsPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-4",
        defaultMessage: "Explain the code changes"
    },
    bitbucketPullRequestsPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-5-1",
        defaultMessage: "Summarize the build logs"
    },
    bitbucketPullRequestsPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-6",
        defaultMessage: "Suggest reviewers for this pull request"
    },
    // BITBUCKET_REPOSITORY_SOURCE
    bitbucketRepositorySourcePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-1",
        defaultMessage: "Explain this file"
    },
    bitbucketRepositorySourcePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-2",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketRepositorySourcePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-3",
        defaultMessage: " What APIs or modules do these files interact with?"
    },
    bitbucketRepositorySourcePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-4",
        defaultMessage: "Find pull requests authored by `person`"
    },
    bitbucketRepositorySourcePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-5",
        defaultMessage: "Find APIs that these files interact with"
    },
    // BITBUCKET_PIPELINES
    bitbucketPipelinePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-1-1",
        defaultMessage: "Summarize the build logs"
    },
    bitbucketPipelinePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-2",
        defaultMessage: "What is the status of the `build`?"
    },
    // BITBUCKET_HOME
    bitbucketPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-1",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-2",
        defaultMessage: "What are the open PRs for the current Jira sprint?"
    },
    bitbucketPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-3",
        defaultMessage: "Has `Jira work item` been deployed?"
    },
    bitbucketPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-4",
        defaultMessage: "Who are the reviewers on this `Pull request`?"
    },
    bitbucketPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-5",
        defaultMessage: "Find pull requests authored by `person`"
    },
    bitbucketPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-6",
        defaultMessage: "Check deployment status of `Jira work item`"
    },
    bitbucketPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.bitbucket.starter-7",
        defaultMessage: "Find reviewers of `pull request`"
    },
    // CONFLUENCE_HOME
    confluenceHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-1",
        defaultMessage: "Is there any new activity on pages I've written?"
    },
    confluenceHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-2",
        defaultMessage: "Are there any new comments mentioning me?"
    },
    confluenceHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-3",
        defaultMessage: "Summarize the most recently published pages in this space."
    },
    confluenceHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-4",
        defaultMessage: "Summarize my contributions to pages from last week."
    },
    confluenceHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-5",
        defaultMessage: "Can you take this `page` and write it in a less technical way?"
    },
    confluenceHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-6",
        defaultMessage: "Create a game plan template for project management."
    },
    confluenceHomePrompt7: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-7",
        defaultMessage: "What research do we have on common customer problems?"
    },
    confluenceHomePrompt8: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-8",
        defaultMessage: "Has anyone on my team published any new pages this week?"
    },
    confluenceHomePrompt9: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-9",
        defaultMessage: "Has `person` published any new pages this week?"
    },
    confluenceHomePrompt10: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-10",
        defaultMessage: "Has `person` commented on any pages that I've published?"
    },
    confluenceHomePrompt11: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-11",
        defaultMessage: "What are the key takeaways from `page`?"
    },
    confluenceHomePrompt12: {
        id: "rovo-conversation-actions.conversation-starters.confluence-home.starter-12",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_VIEW & CONFLUENCE_BLOG_VIEW
    confluencePageViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluencePageViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-2",
        defaultMessage: "Summarize the comments on this page."
    },
    confluencePageViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-3",
        defaultMessage: "Explain this page to me like I'm a beginner."
    },
    confluencePageViewPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-4",
        defaultMessage: "Who wrote this page and what team are they on?"
    },
    confluencePageViewPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-5",
        defaultMessage: "Has anything on this page changed in the last week?"
    },
    confluencePageViewPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-view.starter-6",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_EDIT & CONFLUENCE_BLOG_EDIT
    confluencePageEditPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-1",
        defaultMessage: "Can you improve the writing on this page?"
    },
    confluencePageEditPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-2",
        defaultMessage: "Write an executive summary for this page."
    },
    confluencePageEditPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-3",
        defaultMessage: "Give me links to some other relevant pages."
    },
    confluencePageEditPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluenceWhiteboardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-2",
        defaultMessage: "Highlight any patterns or trends visible here."
    },
    confluenceWhiteboardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-3",
        defaultMessage: "Identify any key action items or decisions captured in this whiteboard."
    },
    confluenceWhiteboardPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_HOME
    jiraHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-1",
        defaultMessage: "Find Jira issues that have been updated this week."
    },
    jiraHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-2",
        defaultMessage: "What Jira issues are the highest priority?"
    },
    jiraHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-3",
        defaultMessage: "What Jira issues have comments mentioning me?"
    },
    jiraHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-4",
        defaultMessage: "Summarize the comments on `Jira issue`."
    },
    jiraHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-5",
        defaultMessage: "Create a description template for user stories."
    },
    jiraHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-home.starter-6",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_FOR_YOU
    jiraForYouPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-for-you.starter-1",
        defaultMessage: "Pull up work items recently assigned to me."
    },
    jiraForYouPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-for-you.starter-2",
        defaultMessage: "Pull up work items where I was mentioned recently."
    },
    jiraForYouPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-for-you.starter-3",
        defaultMessage: "Summarize updates on work items I'm watching."
    },
    jiraForYouPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-for-you.starter-4",
        defaultMessage: "Update the status of my in-progress work."
    },
    jiraForYouPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-for-you.starter-5",
        defaultMessage: "Which of my work items are blocked?"
    },
    jiraForYouPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-for-you.starter-6",
        defaultMessage: "What are the highest-priority work items assigned to me across projects?"
    },
    jiraForYouPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-for-you.starter-7",
        defaultMessage: "What work items assigned to me are due this week?"
    },
    // JIRA_ISSUE_VIEW
    jiraIssueViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-1",
        defaultMessage: "Are there any similar Jira issues to this one?"
    },
    jiraIssueViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-2",
        defaultMessage: "How could I improve the description?"
    },
    jiraIssueViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-3",
        defaultMessage: "What labels could I add to this issue?"
    },
    jiraIssueViewPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-issue-view.starter-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_PROJECT
    jiraProjectPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-1",
        defaultMessage: "What work hasn\u2019t been picked up in a while?"
    },
    jiraProjectPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-2",
        defaultMessage: "Are any Jira issues blocked?"
    },
    jiraProjectPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-3",
        defaultMessage: "List Jira issues that are currently \u201CIn Progress\u201D and group them by assignee."
    },
    jiraProjectPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-4",
        defaultMessage: "How many issues are assigned to `person`?"
    },
    jiraProjectPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-5",
        defaultMessage: "Has `person` commented on any Jira issues in this sprint?"
    },
    jiraProjectPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-6",
        defaultMessage: "What Jira issues are unassigned?"
    },
    jiraProjectPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-7",
        defaultMessage: "What Jira issues have been open the longest?"
    },
    jiraProjectPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-8",
        defaultMessage: "Who has the most tasks?"
    },
    jiraProjectPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-9",
        defaultMessage: "Find and group similar Jira issues."
    },
    jiraProjectPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-10",
        defaultMessage: "Are there any Jira issues not connected to a parent issue?"
    },
    jiraProjectPrompt11: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-11",
        defaultMessage: "Take `Jira issue` description and align it to best-practice."
    },
    jiraProjectPrompt12: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-12",
        defaultMessage: "Summarize the comments on `Jira issue`."
    },
    jiraProjectPrompt13: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-13",
        defaultMessage: "Create a description template for user stories."
    },
    jiraProjectPrompt14: {
        id: "rovo-conversation-actions.conversation-starters.jira-project.starter-14",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_BOARD
    jiraBoardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-1",
        defaultMessage: "Update status for work items in this board."
    },
    jiraBoardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-2",
        defaultMessage: "Update assignee for work items in this board."
    },
    jiraBoardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-3",
        defaultMessage: "Update work items in this board."
    },
    jiraBoardPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-4",
        defaultMessage: "What are the risks for this active sprint?"
    },
    jiraBoardPrompt5: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-5",
        defaultMessage: "How many work items are unassigned in this board?"
    },
    jiraBoardPrompt6: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-6",
        defaultMessage: "Which work items are stale?"
    },
    jiraBoardPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-7",
        defaultMessage: "Which work items are blocked?"
    },
    jiraBoardPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-8",
        defaultMessage: "Summarize this board for me."
    },
    jiraBoardPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-9",
        defaultMessage: "Update work items on this board."
    },
    jiraBoardPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-board.starter-10",
        defaultMessage: "Move work items to a status."
    },
    // JIRA_BACKLOG
    jiraBacklogPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-1",
        defaultMessage: "Find work items assigned to me in this backlog."
    },
    jiraBacklogPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-2",
        defaultMessage: "Update the status of a set of work items in this backlog to `status`."
    },
    jiraBacklogPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-3",
        defaultMessage: "Add the top-ranked work items from this backlog to the upcoming sprint."
    },
    jiraBacklogPrompt4: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-4",
        defaultMessage: "Create new work items in the backlog."
    },
    jiraBacklogPrompt7: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-7",
        defaultMessage: "Move a set of work items in this backlog to the upcoming sprint."
    },
    jiraBacklogPrompt8: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-8",
        defaultMessage: "Write a description for a `Jira work item`."
    },
    jiraBacklogPrompt9: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-9",
        defaultMessage: "Update the summary for a set of work items in this backlog."
    },
    jiraBacklogPrompt10: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-10",
        defaultMessage: "Update the priority of a set of work items in this backlog to `priority`."
    },
    jiraBacklogPrompt11: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-11",
        defaultMessage: "Update the parent for a set of work items in this backlog."
    },
    jiraBacklogPrompt12: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-12",
        defaultMessage: "Are there any Jira issues not connected to a parent issue?"
    },
    jiraBacklogPrompt13: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-13",
        defaultMessage: "Which work items are stale in the backlog?"
    },
    jiraBacklogPrompt14: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-14",
        defaultMessage: "What issues don't have an estimate in the backlog?"
    },
    jiraBacklogPrompt15: {
        id: "rovo-conversation-actions.conversation-starters.jira-backlog.starter-15",
        defaultMessage: "Are there any blocked issues in the backlog?"
    },
    // JSM_INCIDENT_VIEW
    jsmIncidentViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-1",
        defaultMessage: "Find people who can help resolve this incident"
    },
    jsmIncidentViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-2",
        defaultMessage: "Are there any ongoing incidents?"
    },
    jsmIncidentViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-3",
        defaultMessage: "Create a post-incident review (PIR)"
    },
    // JSM_INCIDENT_LIST_VIEW
    jsmIncidentListViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-1",
        defaultMessage: "Are there any ongoing incidents?"
    },
    jsmIncidentListViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-2",
        defaultMessage: "Get me the open high priority incidents"
    },
    jsmIncidentListViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-3",
        defaultMessage: "Are there any open alerts?"
    },
    // JSM_ALERT_VIEW (Alert details page)
    jsmAlertViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-2",
        defaultMessage: "Investigate this alert"
    },
    jsmAlertViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // JSM_ALERT_LIST_VIEW (Alert list page)
    jsmAlertListViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertListViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-2",
        defaultMessage: "Find recently closed alerts"
    },
    jsmAlertListViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // JSM_ALERT_GROUP_DETAIL_VIEW (Alert group details page)
    jsmAlertGroupDetailViewPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-1",
        defaultMessage: "Find open alerts"
    },
    jsmAlertGroupDetailViewPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-2",
        defaultMessage: "Find recently closed alerts"
    },
    jsmAlertGroupDetailViewPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-3",
        defaultMessage: "Are there any ongoing incidents?"
    },
    // ATLAS HOME
    atlasHomePrompt1: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-1",
        defaultMessage: "What Confluence pages have I contributed to recently?"
    },
    atlasHomePrompt2: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-2",
        defaultMessage: "Find all Jira tickets that are assigned to me."
    },
    atlasHomePrompt3: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-3",
        defaultMessage: "What is our travel policy?"
    },
    atlasHomePrompt4: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-4",
        defaultMessage: "Draft a Confluence page for a marketing campaign."
    },
    atlasHomePrompt5: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-5",
        defaultMessage: "How can I create a project timeline?"
    },
    atlasHomePrompt6: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-6",
        defaultMessage: "Write a follow up email to potential clients."
    },
    atlasHomePrompt7: {
        id: "rovo-conversation-actions.conversation-starters.atlas-home.starter-7",
        defaultMessage: "What should I work on next?"
    },
    // FOCUS
    focusPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus.starter-1",
        defaultMessage: "Summarize my focus areas."
    },
    focusPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.focus.starter-2",
        defaultMessage: "Identify gaps and highlight risks."
    },
    // FOCUS_FOCUS_AREA_PAGE
    focusAreaPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area.starter-1",
        defaultMessage: "Summarize this focus area."
    },
    // FOCUS_FOCUS_AREA_GOAL_VIEW
    focusAreaGoalPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-goal.starter-1",
        defaultMessage: "Summarize the goals linked to this focus area."
    },
    // FOCUS_FOCUS_AREA_WORK_VIEW
    focusAreaWorkPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-work.starter-1",
        defaultMessage: "Summarize the work linked to this focus area."
    },
    // FOCUS_FOCUS_AREA_FUNDS_VIEW
    focusAreaFundsPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-funds.starter-1",
        defaultMessage: "Analyze the funds linked to this focus area."
    },
    focusAreaFundsBetaBadge: {
        id: "rovo-conversation-actions.conversation-starters.focus-area-funds.beta-badge",
        defaultMessage: "Beta"
    },
    // FOCUS_FOR_YOU
    focusForYouPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.focus-for-you.starter-1",
        defaultMessage: "Summarize my focus areas."
    },
    // SAC
    sacPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-1",
        defaultMessage: "How do I manage settings?"
    },
    sacPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-2",
        defaultMessage: "How do I find information?"
    },
    sacPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.sac.starter-3",
        defaultMessage: "How do I create an automation rule?"
    },
    // TRELLO_BOARD (board/universal rovo button)
    trelloBoardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-1",
        defaultMessage: "Summarize this board."
    },
    trelloBoardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-2",
        defaultMessage: "Suggest ways to organize this board."
    },
    trelloBoardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.trello-board.starter-3",
        defaultMessage: "What should my top 3 priorities be today?"
    },
    // TRELLO_CARD (cardback)
    trelloCardPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-1",
        defaultMessage: "Summarize this card."
    },
    trelloCardPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-2",
        defaultMessage: "Find work related to this card."
    },
    trelloCardPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.trello-card.starter-3",
        defaultMessage: "Suggest improvements for this card's description."
    },
    // UNKNOWN
    unknownPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-1",
        defaultMessage: "Are any of my work items overdue?"
    },
    unknownPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-2",
        defaultMessage: "What should I work on next?"
    },
    unknownPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.unknown.starter-3",
        defaultMessage: "Write an update about my week."
    },
    studioAgentBuilderPrompt1: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-1",
        defaultMessage: "Personalize this agent to my needs"
    },
    studioAgentBuilderPrompt2: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-2",
        defaultMessage: "What other tools could I add?"
    },
    studioAgentBuilderPrompt3: {
        id: "rovo-conversation-actions.conversation-starters.studio-agent-builder.starter-3",
        defaultMessage: "Find more knowledge sources"
    }
});
var $b0ccb00ee4479897$export$2e2bcd8739ae039 = $b0ccb00ee4479897$var$_default_1;
module.exports["default"] = $b0ccb00ee4479897$export$2e2bcd8739ae039;

});

parcelRegister("gxmD5", function(module, exports) {
const $2f7f93fb83392ebb$export$cb9fc4c34a0afb34 = {
    lastSeenAt: 0,
    exposureCount: 0,
    onboardingCompleted: false
};
module.exports["DEFAULT_HOLDOUT_STATE"] = $2f7f93fb83392ebb$export$cb9fc4c34a0afb34;

});

parcelRegister("advdT", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $9O4fI = parcelRequire("9O4fI");


var $aWbI3 = parcelRequire("aWbI3");

function $35b5f67ffede8a05$export$70098a1ba52d021f() {
    try {
        return (0, $aWbI3.parseState)((0, $7dBf8.AtlBrowserStorageLocal).getItem((0, $9O4fI.LS_ONBOARDING_HOLDOUT_KEY)));
    } catch  {
        return null;
    }
}
module.exports["getOnboardingHoldoutState"] = $35b5f67ffede8a05$export$70098a1ba52d021f;

});

parcelRegister("9O4fI", function(module, exports) {
/**
 * Onboarding holdout feature: gate onboarding behind a 24h cooldown, a max of 3 exposures,
 * and don't-show-again-after-completion. This module defines the holdout tunables
 * (cooldown, exposure cap, storage key) and the persisted state shape. State is read/written
 * via the get/persist helpers using AtlBrowserStorageLocal; if productionized, consider a more
 * permanent source (e.g. backend or user preferences).
 */ 
var $oV0CU = parcelRequire("oV0CU");

const $1243988fe5d236ac$export$124df12a015901ba = 'rovoOnboardingHoldout';
const $1243988fe5d236ac$export$a478a0028a108fe6 = 3;
const $1243988fe5d236ac$export$af9030d6dd88ec25 = 24 * (0, $oV0CU.SECONDS_IN_HR) * (0, $oV0CU.MS_IN_SECOND);
module.exports["LS_ONBOARDING_HOLDOUT_KEY"] = $1243988fe5d236ac$export$124df12a015901ba;
module.exports["MAX_ONBOARDING_EXPOSURES"] = $1243988fe5d236ac$export$a478a0028a108fe6;
module.exports["HOLDOUT_MS"] = $1243988fe5d236ac$export$af9030d6dd88ec25;

});

parcelRegister("aWbI3", function(module, exports) {

var $9O4fI = parcelRequire("9O4fI");

function $12e24d7a304110aa$export$adb402f717f36848(raw) {
    if (raw === null) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed.lastSeenAt === 'number' && typeof parsed.exposureCount === 'number') return {
        lastSeenAt: parsed.lastSeenAt,
        exposureCount: Math.min(Math.max(0, Math.floor(parsed.exposureCount)), (0, $9O4fI.MAX_ONBOARDING_EXPOSURES)),
        onboardingCompleted: parsed.onboardingCompleted === true
    };
    return null;
}
module.exports["parseState"] = $12e24d7a304110aa$export$adb402f717f36848;

});

parcelRegister("3LpEG", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $9O4fI = parcelRequire("9O4fI");

function $a9ad9738d21e6d42$export$9f127573fd964184(state) {
    try {
        (0, $7dBf8.AtlBrowserStorageLocal).setItem((0, $9O4fI.LS_ONBOARDING_HOLDOUT_KEY), JSON.stringify(state));
    } catch  {
    // AtlBrowserStorageLocal may be full or unavailable (e.g. private browsing in Safari)
    }
}
module.exports["persistState"] = $a9ad9738d21e6d42$export$9f127573fd964184;

});

parcelRegister("fBd2O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $cK21K = parcelRequire("cK21K");


var $8akfd = parcelRequire("8akfd");


var $dSCNl = parcelRequire("dSCNl");


var $dPoYT = parcelRequire("dPoYT");


var $2FUOC = parcelRequire("2FUOC");

const $f5c1836cf94a50bb$var$CONVERSATION_ASSISTANT_MINIMUM_HEIGHT = 350;
const $f5c1836cf94a50bb$var$styles = {
    wrapper: "_24h04i2Njc _39xV02Cylp _3138425zaO _0jFU0VlGYu _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXFlnN _0hPCNLFlnN",
    wrapperNav4: "_24h04i2Njc _39xV02N91d _0jFU0VN91d _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXFlnN _0hPCNLFlnN",
    wrapperHeight: "_4kiQYAaQBb",
    externalEmbed: "_313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _39xV02N91d _0jFU0VN91d",
    fullscreenDebug: "_49OCfRPgdg _1mT5xdy1CL _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0jFU0VZqHV _39xV02ZqHV",
    withExternalStagingArea: "_39xV02N91d"
};
const $f5c1836cf94a50bb$var$stylesBorder = {
    borderNavV3: "_3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _2C2kUQ8fU6 _1Lz9lo8fU6",
    borderNavV4: "",
    borderFullScreenDebug: "_0bjKvD8fU6 _3hxITi6wH8 _3vBAKHQvmT _2V7sgO8fU6",
    borderExternalEmbed: "",
    borderStagingArea: "_0bjKvDyzSk _2OUyjtzwhj"
};
const $f5c1836cf94a50bb$var$miniModalWrapperStyles = null;
const $f5c1836cf94a50bb$export$6661021c36f0a701 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode } = t0;
    const isMiniModal = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isContextPanelEnabled: isContextPanelEnabled } = (0, $dSCNl.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    let t1;
    if ($[0] !== children || $[1] !== isContextPanelEnabled || $[2] !== isMiniModal) {
        t1 = ()=>{
            if (!isContextPanelEnabled || !(0, $iDrrr.fg)("agent_session_experience_fg")) return children;
            return /*#__PURE__*/ $cozmU.createElement((0, $2FUOC.SessionContextLayout), {
                isMiniModal: isMiniModal
            }, children);
        };
        $[0] = children;
        $[1] = isContextPanelEnabled;
        $[2] = isMiniModal;
        $[3] = t1;
    } else t1 = $[3];
    const renderInnerChildren = t1;
    const shouldShowStagingArea = stagingAreaMode === "inline";
    const fullscreenDebugEnabled = localStorage.getItem("DEBUG_rovo_chat_fullscreen") === "true" && (0, $iDrrr.fg)("rovo_chat_show_local_frontend_components");
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) {
        const t2 = shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper;
        const t3 = isMiniModal ? "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _0jFU0VIZbP _1kOSYtLaAG _3Z9K0wAS8f _0qk6IKDMeZ" : $f5c1836cf94a50bb$var$styles.wrapperHeight;
        const t4 = externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed;
        let t5;
        if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
            t5 = (0, $hekY6.default)([
                t2,
                t3,
                t4,
                $f5c1836cf94a50bb$var$styles.fullscreenDebug,
                $f5c1836cf94a50bb$var$stylesBorder.borderFullScreenDebug
            ]);
            $[4] = t2;
            $[5] = t3;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        let t6;
        if ($[8] !== renderInnerChildren) {
            t6 = renderInnerChildren();
            $[8] = renderInnerChildren;
            $[9] = t6;
        } else t6 = $[9];
        let t7;
        if ($[10] !== t5 || $[11] !== t6 || $[12] !== testId) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
                zIndex: 500
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                "data-testid": testId,
                "data-rovo-chat-panel": "true",
                className: t5
            }, t6));
            $[10] = t5;
            $[11] = t6;
            $[12] = testId;
            $[13] = t7;
        } else t7 = $[13];
        return t7;
    }
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return "borderStagingArea";
        if (externalEmbed) return "borderExternalEmbed";
        if (fullscreenDebugEnabled) return "borderFullScreenDebug";
        if (shouldUseWrapperNav4Styles) return "borderNavV4";
        return "borderNavV3";
    };
    const t2 = shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper;
    const t3 = isMiniModal ? "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _0jFU0VIZbP _1kOSYtLaAG _3Z9K0wAS8f _0qk6IKDMeZ" : $f5c1836cf94a50bb$var$styles.wrapperHeight;
    const t4 = externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed;
    const t5 = $f5c1836cf94a50bb$var$stylesBorder[getBorderStyle()];
    const t6 = fullScreen && shouldShowStagingArea && $f5c1836cf94a50bb$var$styles.withExternalStagingArea;
    let t7;
    if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
        t7 = (0, $hekY6.default)([
            t2,
            t3,
            t4,
            t5,
            t6
        ]);
        $[14] = t2;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== renderInnerChildren) {
        t8 = renderInnerChildren();
        $[20] = renderInnerChildren;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== t7 || $[23] !== t8 || $[24] !== testId) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            "data-rovo-chat-panel": "true",
            className: t7
        }, t8);
        $[22] = t7;
        $[23] = t8;
        $[24] = testId;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
} : ({ testId: testId, children: children, isNav4Enabled: isNav4Enabled, mode: mode })=>{
    const isMiniModal = mode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const { externalEmbed: externalEmbed, fullScreen: fullScreen, elements: elements, isContextPanelEnabled: isContextPanelEnabled } = (0, $dSCNl.useUIConfig)();
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    const renderInnerChildren = ()=>{
        if (!isContextPanelEnabled || !(0, $iDrrr.fg)('agent_session_experience_fg')) return children;
        return /*#__PURE__*/ $cozmU.createElement((0, $2FUOC.SessionContextLayout), {
            isMiniModal: isMiniModal
        }, children);
    };
    const shouldShowStagingArea = stagingAreaMode === 'inline'; // Purely for FE team testing fullscreen where branch deploys are accessible
    // The use of localStorage and a private FF should make this safe, and it's our
    // best bet to improve dev velocity at the moment. Once Atlas has local consumption
    // we can remove this
    const fullscreenDebugEnabled = // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $iDrrr.fg)('rovo_chat_show_local_frontend_components');
    const shouldUseWrapperNav4Styles = isNav4Enabled;
    if (fullscreenDebugEnabled) return /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
        zIndex: 500
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $hekY6.default)([
            shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper,
            isMiniModal ? "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _0jFU0VIZbP _1kOSYtLaAG _3Z9K0wAS8f _0qk6IKDMeZ" : $f5c1836cf94a50bb$var$styles.wrapperHeight,
            externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed,
            $f5c1836cf94a50bb$var$styles.fullscreenDebug,
            $f5c1836cf94a50bb$var$stylesBorder.borderFullScreenDebug
        ])
    }, renderInnerChildren()));
    const getBorderStyle = ()=>{
        if (elements?.stagingAreaEnabled) return 'borderStagingArea';
        if (externalEmbed) return 'borderExternalEmbed';
        if (fullscreenDebugEnabled) // this is not possible because if condition above, but adding it here for completeness
        return 'borderFullScreenDebug';
        if (shouldUseWrapperNav4Styles) return 'borderNavV4';
        return 'borderNavV3';
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        "data-rovo-chat-panel": "true",
        className: (0, $hekY6.default)([
            shouldUseWrapperNav4Styles ? $f5c1836cf94a50bb$var$styles.wrapperNav4 : $f5c1836cf94a50bb$var$styles.wrapper,
            isMiniModal ? "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _0jFU0VIZbP _1kOSYtLaAG _3Z9K0wAS8f _0qk6IKDMeZ" : $f5c1836cf94a50bb$var$styles.wrapperHeight,
            externalEmbed && $f5c1836cf94a50bb$var$styles.externalEmbed,
            $f5c1836cf94a50bb$var$stylesBorder[getBorderStyle()],
            fullScreen && shouldShowStagingArea && $f5c1836cf94a50bb$var$styles.withExternalStagingArea
        ])
    }, renderInnerChildren());
};
module.exports["MainWrapper"] = $f5c1836cf94a50bb$export$6661021c36f0a701;

});

parcelRegister("2FUOC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $7o2Oy = parcelRequire("7o2Oy");


var $iehIX = parcelRequire("iehIX");


var $axKZp = parcelRequire("axKZp");

const $0ddc8c1cb3dfb4b8$var$styles = {
    overlayHost: "_0bjKvDOLYo _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4kiQYAdnbC"
};
const $0ddc8c1cb3dfb4b8$export$9a828967a77275b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { children: children, isMiniModal: isMiniModal } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [presentation, setPresentation] = (0, $cozmU.useState)(null);
    const rightPanelExitHandlerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setPresentation(null);
        $[0] = t1;
    } else t1 = $[0];
    const closeSessionContext = t1;
    let t2;
    if ($[1] !== isMiniModal || $[2] !== sendAnalyticsEvent) {
        t2 = (requestedPresentation)=>{
            const nextPresentation = isMiniModal ? "drawer" : requestedPresentation;
            setPresentation(nextPresentation);
            sendAnalyticsEvent({
                action: "viewed",
                actionSubject: "sessionContextPanel",
                attributes: {
                    presentation: nextPresentation
                }
            });
            return nextPresentation;
        };
        $[1] = isMiniModal;
        $[2] = sendAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    const openSessionContext = t2;
    let t3;
    if ($[4] !== openSessionContext || $[5] !== presentation) {
        t3 = {
            presentation: presentation,
            openSessionContext: openSessionContext,
            closeSessionContext: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        };
        $[4] = openSessionContext;
        $[5] = presentation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $0ddc8c1cb3dfb4b8$var$styles.overlayHost
        ]);
        $[7] = t4;
    } else t4 = $[7];
    const t5 = presentation === "split";
    let t6;
    if ($[8] !== children || $[9] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $7o2Oy.SplitLayout), {
            isRightPanelVisible: t5,
            onAutoCollapse: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        }, children);
        $[8] = children;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const t7 = presentation === "drawer";
    let t8;
    if ($[11] !== isMiniModal || $[12] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $axKZp.SessionContextPanelDrawer), {
            isOpen: t7,
            isMiniModal: isMiniModal
        });
        $[11] = isMiniModal;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== t6 || $[15] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t4
        }, t6, t8);
        $[14] = t6;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t3 || $[18] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iehIX.SplitViewContext).Provider, {
            value: t3
        }, t9);
        $[17] = t3;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    return t10;
} : ({ children: children, isMiniModal: isMiniModal })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [presentation, setPresentation] = (0, $cozmU.useState)(null);
    const rightPanelExitHandlerRef = (0, $cozmU.useRef)(null);
    const closeSessionContext = (0, $cozmU.useCallback)(()=>setPresentation(null), []);
    const openSessionContext = (0, $cozmU.useCallback)((requestedPresentation)=>{
        const nextPresentation = isMiniModal ? 'drawer' : requestedPresentation;
        setPresentation(nextPresentation);
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'sessionContextPanel',
            attributes: {
                presentation: nextPresentation
            }
        });
        return nextPresentation;
    }, [
        isMiniModal,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iehIX.SplitViewContext).Provider, {
        value: {
            presentation: presentation,
            openSessionContext: openSessionContext,
            closeSessionContext: closeSessionContext,
            rightPanelExitHandlerRef: rightPanelExitHandlerRef
        }
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $0ddc8c1cb3dfb4b8$var$styles.overlayHost
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7o2Oy.SplitLayout), {
        isRightPanelVisible: presentation === 'split',
        onAutoCollapse: closeSessionContext,
        rightPanelExitHandlerRef: rightPanelExitHandlerRef
    }, children), /*#__PURE__*/ $cozmU.createElement((0, $axKZp.SessionContextPanelDrawer), {
        isOpen: presentation === 'drawer',
        isMiniModal: isMiniModal
    })));
};
module.exports["SessionContextLayout"] = $0ddc8c1cb3dfb4b8$export$9a828967a77275b7;

});

parcelRegister("7o2Oy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $cbY7C = parcelRequire("cbY7C");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");


var $hBYtq = parcelRequire("hBYtq");


var $oV0CU = parcelRequire("oV0CU");


var $cSfOO = parcelRequire("cSfOO");


var $Vl9MW = parcelRequire("Vl9MW");


var $6FfVp = parcelRequire("6FfVp");

const $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH = 4;
const $abb6876f0c761819$var$messages = (0, $kSwu1.defineMessages)({
    resizeSidePanelAriaLabel: {
        id: "ai-mate.conversation-assistant.split-layout.resize-side-panel-aria-label",
        defaultMessage: "Resize side panel"
    }
});
const $abb6876f0c761819$var$styles = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _24h04i2Njc _4xdlr0FlnN _0jFU0VN91d _39xV02N91d _4kiQYAdnbC _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLFlnN",
    leftPane: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4xdlr0FlnN _0jFU0VN91d _4kiQYAdnbC _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLFlnN",
    rightPanel: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _24h04i2Njc _4xdlr0FlnN _0jFU0VN91d _4kiQYAdnbC _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLFlnN _1Vs123NvrM _421I1o6wH8 _0obpEh9r67",
    resizeHandle: "_30huDKYbGa _23rrnHb6HL _39xV02UNDJ _4xdlr0FlnN _1mT5xdRAKS _0wOv4QYNYw _0KLXrujOvk _1JM8vvb6HL _0GBAIrogpp _2WYcYGWVPG _2ZHpDR715P _2KaDuOdnbC _4zi1EpdnbC _2jfUf94Jdh _3wEj0XjOvk _0PxRoQjssS _0jKh9gDM2k",
    resizeHandleDragging: "_3wEj0XDM2k"
};
const $abb6876f0c761819$var$isBrowser = typeof window !== 'undefined';
const $abb6876f0c761819$var$readPersistedWidth = (storageKey)=>{
    if (!storageKey || !$abb6876f0c761819$var$isBrowser) return null;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = window.localStorage.getItem(storageKey);
        if (raw == null) return null;
        const parsed = Number.parseFloat(raw);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    } catch  {
        return null;
    }
};
const $abb6876f0c761819$var$writePersistedWidth = (storageKey, width)=>{
    if (!storageKey || !$abb6876f0c761819$var$isBrowser) return;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.setItem(storageKey, String(Math.round(width)));
    } catch  {}
}; /**
    * Renders a horizontal split layout:
    *   [ chat children (flex-grow left pane) ] [ resize handle ] [ right panel (sized) ]
    *
    * - The chat (left) uses `flex: 1` so it always absorbs surplus horizontal
    *   space and is the visually dominant pane.
    * - The right panel has an explicit pixel width that the user can drag.
    *
    * The drag math is a mirror of `useResizablePanel`: `rightWidth = containerRight
    * - clientX`, clamped so the chat keeps at least `minWidth`, the right panel keeps at least
    * `adjacentMinWidth`, and the right panel never becomes wider than the chat.
    */ 
const $abb6876f0c761819$export$581077d6f0ab5bc7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    const { initialWidth: t1, minWidth: t2, adjacentMinWidth: t3, storageKey: t4, children: children, isRightPanelVisible: t5, onAutoCollapse: onAutoCollapse, rightPanelExitHandlerRef: rightPanelExitHandlerRef } = t0;
    const initialWidth = t1 === undefined ? (0, $oV0CU.SPLIT_LAYOUT_INITIAL_WIDTH) : t1;
    const minWidth = t2 === undefined ? (0, $oV0CU.SPLIT_LAYOUT_MIN_WIDTH) : t2;
    const adjacentMinWidth = t3 === undefined ? (0, $oV0CU.SPLIT_LAYOUT_ADJACENT_MIN_WIDTH) : t3;
    const storageKey = t4 === undefined ? (0, $oV0CU.SPLIT_LAYOUT_STORAGE_KEY) : t4;
    const isRightPanelVisible = t5 === undefined ? true : t5;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null);
    const onAutoCollapseRef = (0, $cozmU.useRef)(onAutoCollapse);
    let t6;
    if ($[0] !== adjacentMinWidth || $[1] !== initialWidth || $[2] !== storageKey) {
        t6 = ()=>{
            const persisted = $abb6876f0c761819$var$readPersistedWidth(storageKey);
            const seed = persisted ?? initialWidth;
            return Math.max(seed, adjacentMinWidth);
        };
        $[0] = adjacentMinWidth;
        $[1] = initialWidth;
        $[2] = storageKey;
        $[3] = t6;
    } else t6 = $[3];
    const [rightWidth, setRightWidth] = (0, $cozmU.useState)(t6);
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const [isRightPanelMounted, setIsRightPanelMounted] = (0, $cozmU.useState)(isRightPanelVisible);
    const rightWidthRef = (0, $cozmU.useRef)(rightWidth);
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (e)=>{
            e.preventDefault();
            setIsDragging(true);
        };
        $[4] = t7;
    } else t7 = $[4];
    const handleMouseDown = t7;
    let t8;
    if ($[5] !== adjacentMinWidth || $[6] !== isDragging || $[7] !== minWidth) {
        t8 = (e_0)=>{
            if (!isDragging || !containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();
            const proposed = rect.right - e_0.clientX;
            const maxRight = Math.max(adjacentMinWidth, Math.min(rect.width - minWidth, (rect.width - $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH) / 2));
            setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
        };
        $[5] = adjacentMinWidth;
        $[6] = isDragging;
        $[7] = minWidth;
        $[8] = t8;
    } else t8 = $[8];
    const handleMouseMove = t8;
    let t9;
    if ($[9] !== storageKey) {
        t9 = ()=>{
            setIsDragging(false);
            $abb6876f0c761819$var$writePersistedWidth(storageKey, rightWidthRef.current);
        };
        $[9] = storageKey;
        $[10] = t9;
    } else t9 = $[10];
    const handleMouseUp = t9;
    let t10;
    let t11;
    if ($[11] !== isRightPanelVisible) {
        t10 = ()=>{
            if (isRightPanelVisible) setIsRightPanelMounted(true);
        };
        t11 = [
            isRightPanelVisible
        ];
        $[11] = isRightPanelVisible;
        $[12] = t10;
        $[13] = t11;
    } else {
        t10 = $[12];
        t11 = $[13];
    }
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[14] !== rightWidth) {
        t12 = ()=>{
            rightWidthRef.current = rightWidth;
        };
        t13 = [
            rightWidth
        ];
        $[14] = rightWidth;
        $[15] = t12;
        $[16] = t13;
    } else {
        t12 = $[15];
        t13 = $[16];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    let t15;
    if ($[17] !== onAutoCollapse) {
        t14 = ()=>{
            onAutoCollapseRef.current = onAutoCollapse;
        };
        t15 = [
            onAutoCollapse
        ];
        $[17] = onAutoCollapse;
        $[18] = t14;
        $[19] = t15;
    } else {
        t14 = $[18];
        t15 = $[19];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    let t17;
    if ($[20] !== isRightPanelVisible) {
        t16 = ()=>{
            if (!isRightPanelVisible || !$abb6876f0c761819$var$isBrowser || typeof ResizeObserver === "undefined") return;
            const container = containerRef.current;
            if (!container) return;
            let previousWidth = null;
            const observer = new ResizeObserver((entries)=>{
                for (const entry of entries){
                    const { width: width } = entry.contentRect;
                    const isShrinking = previousWidth !== null && width < previousWidth;
                    if (isShrinking && width < (0, $oV0CU.SPLIT_LAYOUT_MIN_PANEL_WIDTH)) onAutoCollapseRef.current?.();
                    previousWidth = width;
                }
            });
            observer.observe(container);
            return ()=>{
                observer.disconnect();
            };
        };
        t17 = [
            isRightPanelVisible
        ];
        $[20] = isRightPanelVisible;
        $[21] = t16;
        $[22] = t17;
    } else {
        t16 = $[21];
        t17 = $[22];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    let t19;
    if ($[23] !== handleMouseMove || $[24] !== handleMouseUp || $[25] !== isDragging) {
        t18 = ()=>{
            if (!isDragging) return;
            const doc = (0, $1hQ0e.getDocument)();
            if (!doc) return;
            const unbindMouseMove = (0, $cbY7C.bind)(doc, {
                type: "mousemove",
                listener: handleMouseMove
            });
            const unbindMouseUp = (0, $cbY7C.bind)(doc, {
                type: "mouseup",
                listener: handleMouseUp
            });
            return ()=>{
                unbindMouseMove();
                unbindMouseUp();
            };
        };
        t19 = [
            isDragging,
            handleMouseMove,
            handleMouseUp
        ];
        $[23] = handleMouseMove;
        $[24] = handleMouseUp;
        $[25] = isDragging;
        $[26] = t18;
        $[27] = t19;
    } else {
        t18 = $[26];
        t19 = $[27];
    }
    (0, $cozmU.useEffect)(t18, t19);
    const t20 = `${rightWidth}px`;
    const t21 = isDragging ? "none" : undefined;
    let t22;
    if ($[28] !== t20 || $[29] !== t21) {
        t22 = {
            width: t20,
            maxWidth: `calc(50% - ${$abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH / 2}px)`,
            pointerEvents: t21
        };
        $[28] = t20;
        $[29] = t21;
        $[30] = t22;
    } else t22 = $[30];
    const rightStyle = t22;
    let t23;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.root
        ]);
        $[31] = t23;
    } else t23 = $[31];
    let t24;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.leftPane
        ]);
        $[32] = t24;
    } else t24 = $[32];
    let t25;
    if ($[33] !== children) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout-left",
            className: t24
        }, children);
        $[33] = children;
        $[34] = t25;
    } else t25 = $[34];
    let t26;
    if ($[35] !== formatMessage || $[36] !== isDragging || $[37] !== isRightPanelMounted) {
        t26 = isRightPanelMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $k12R1.cx)($abb6876f0c761819$var$styles.resizeHandle, isDragging && $abb6876f0c761819$var$styles.resizeHandleDragging),
            "data-dragging": isDragging,
            testId: "conversation-assistant-split-layout-resize-handle",
            onMouseDown: handleMouseDown,
            "aria-label": formatMessage($abb6876f0c761819$var$messages.resizeSidePanelAriaLabel)
        });
        $[35] = formatMessage;
        $[36] = isDragging;
        $[37] = isRightPanelMounted;
        $[38] = t26;
    } else t26 = $[38];
    let t27;
    if ($[39] !== isRightPanelVisible || $[40] !== rightPanelExitHandlerRef || $[41] !== rightStyle) {
        t27 = isRightPanelVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "right",
            fade: "inout",
            duration: "medium",
            onFinish: (state)=>{
                if (state === "exiting") {
                    setIsRightPanelMounted(false);
                    const exitHandler = rightPanelExitHandlerRef?.current;
                    if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = null;
                    exitHandler?.();
                }
            }
        }, (t28)=>{
            const { className: className, ref: ref } = t28;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $abb6876f0c761819$var$styles.rightPanel,
                    className
                ]),
                ref: ref,
                "data-testid": "conversation-assistant-split-layout-right",
                style: rightStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSfOO.SessionRightPanelErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vl9MW.SessionRightPanelLazy), null))));
        });
        $[39] = isRightPanelVisible;
        $[40] = rightPanelExitHandlerRef;
        $[41] = rightStyle;
        $[42] = t27;
    } else t27 = $[42];
    let t28;
    if ($[43] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, t27);
        $[43] = t27;
        $[44] = t28;
    } else t28 = $[44];
    let t29;
    if ($[45] !== t25 || $[46] !== t26 || $[47] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "conversation-assistant-split-layout",
            ref: containerRef,
            className: t23
        }, t25, t26, t28);
        $[45] = t25;
        $[46] = t26;
        $[47] = t28;
        $[48] = t29;
    } else t29 = $[48];
    return t29;
} : ({ initialWidth: initialWidth = (0, $oV0CU.SPLIT_LAYOUT_INITIAL_WIDTH), minWidth: minWidth = (0, $oV0CU.SPLIT_LAYOUT_MIN_WIDTH), adjacentMinWidth: adjacentMinWidth = (0, $oV0CU.SPLIT_LAYOUT_ADJACENT_MIN_WIDTH), storageKey: storageKey = (0, $oV0CU.SPLIT_LAYOUT_STORAGE_KEY), children: children, isRightPanelVisible: isRightPanelVisible = true, onAutoCollapse: onAutoCollapse, rightPanelExitHandlerRef: rightPanelExitHandlerRef })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null); // Mirror the callback to a ref so the resize observer below doesn't need to re-subscribe every time the host passes a new callback identity.
    const onAutoCollapseRef = (0, $cozmU.useRef)(onAutoCollapse); // Lazy initializer so we only touch `localStorage` once on mount. The persisted value (if any) wins over the explicit `initialWidth` prop.
    const [rightWidth, setRightWidth] = (0, $cozmU.useState)(()=>{
        const persisted = $abb6876f0c761819$var$readPersistedWidth(storageKey);
        const seed = persisted ?? initialWidth;
        return Math.max(seed, adjacentMinWidth);
    });
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const [isRightPanelMounted, setIsRightPanelMounted] = (0, $cozmU.useState)(isRightPanelVisible); // Latest width is mirrored to a ref so the `mouseup` handler can persist without being recreated (and re-binding listeners) on every drag tick.
    const rightWidthRef = (0, $cozmU.useRef)(rightWidth);
    const handleMouseDown = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setIsDragging(true);
    }, []);
    const handleMouseMove = (0, $cozmU.useCallback)((e_0)=>{
        if (!isDragging || !containerRef.current) return;
        const rect = containerRef.current.getBoundingClientRect();
        const proposed = rect.right - e_0.clientX;
        const maxRight = Math.max(adjacentMinWidth, Math.min(rect.width - minWidth, (rect.width - $abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH) / 2));
        setRightWidth(Math.max(adjacentMinWidth, Math.min(maxRight, proposed)));
    }, [
        isDragging,
        minWidth,
        adjacentMinWidth
    ]);
    const handleMouseUp = (0, $cozmU.useCallback)(()=>{
        setIsDragging(false); // Persist the resting width once per drag (not on every mousemove tick).
        $abb6876f0c761819$var$writePersistedWidth(storageKey, rightWidthRef.current);
    }, [
        storageKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isRightPanelVisible) setIsRightPanelMounted(true);
    }, [
        isRightPanelVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        rightWidthRef.current = rightWidth;
    }, [
        rightWidth
    ]);
    (0, $cozmU.useEffect)(()=>{
        onAutoCollapseRef.current = onAutoCollapse;
    }, [
        onAutoCollapse
    ]); // When the panel the chat lives in is resized narrower than the split-layout minimum, auto-collapse the right panel
    (0, $cozmU.useEffect)(()=>{
        if (!isRightPanelVisible || !$abb6876f0c761819$var$isBrowser || typeof ResizeObserver === 'undefined') return;
        const container = containerRef.current;
        if (!container) return;
         // Collapse the right panel only when the user actively *narrows* the container below the split
        // minimum — i.e. the width is shrinking. Acting on the shrink direction (rather than any narrow
        // reading) means we ignore the panel growing as it expands on open, so a just-opened split is
        // never collapsed mid-expansion, and a split that simply opened narrow isn't yanked away —
        // only a deliberate narrowing hides it.
        let previousWidth = null;
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const { width: width } = entry.contentRect;
                const isShrinking = previousWidth !== null && width < previousWidth;
                if (isShrinking && width < (0, $oV0CU.SPLIT_LAYOUT_MIN_PANEL_WIDTH)) onAutoCollapseRef.current?.();
                previousWidth = width;
            }
        });
        observer.observe(container);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isRightPanelVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isDragging) return;
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
        const unbindMouseMove = (0, $cbY7C.bind)(doc, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        const unbindMouseUp = (0, $cbY7C.bind)(doc, {
            type: 'mouseup',
            listener: handleMouseUp
        });
        return ()=>{
            unbindMouseMove();
            unbindMouseUp();
        };
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    const rightStyle = {
        width: `${rightWidth}px`,
        maxWidth: `calc(50% - ${$abb6876f0c761819$var$SPLIT_LAYOUT_RESIZE_HANDLE_WIDTH / 2}px)`,
        pointerEvents: isDragging ? 'none' : undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout",
        ref: containerRef,
        className: (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "conversation-assistant-split-layout-left",
        className: (0, $hekY6.default)([
            $abb6876f0c761819$var$styles.leftPane
        ])
    }, children), isRightPanelMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $k12R1.cx)($abb6876f0c761819$var$styles.resizeHandle, isDragging && $abb6876f0c761819$var$styles.resizeHandleDragging),
        "data-dragging": isDragging,
        testId: "conversation-assistant-split-layout-resize-handle",
        onMouseDown: handleMouseDown,
        "aria-label": formatMessage($abb6876f0c761819$var$messages.resizeSidePanelAriaLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isRightPanelVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
        enterFrom: "right",
        fade: "inout",
        duration: "medium",
        onFinish: (state)=>{
            if (state === 'exiting') {
                setIsRightPanelMounted(false);
                const exitHandler = rightPanelExitHandlerRef?.current;
                if (rightPanelExitHandlerRef) rightPanelExitHandlerRef.current = null;
                exitHandler?.();
            }
        }
    }, ({ className: className, ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- required to forward the motion animation class from @atlaskit/motion's SlideIn render prop
        , {
            className: (0, $hekY6.default)([
                $abb6876f0c761819$var$styles.rightPanel,
                className
            ]),
            ref: ref,
            "data-testid": "conversation-assistant-split-layout-right",
            style: rightStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSfOO.SessionRightPanelErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vl9MW.SessionRightPanelLazy), null)))))));
};
module.exports["SplitLayout"] = $abb6876f0c761819$export$581077d6f0ab5bc7;

});

parcelRegister("cSfOO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");

const $5af5774e7bfbd5b4$var$messages = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "ai-mate.conversation-assistant.session-right-panel.error-boundary-title-non-final",
        defaultMessage: "Something went wrong"
    },
    reloadLink: {
        id: "ai-mate.conversation-assistant.session-right-panel.error-boundary-reload-link-non-final",
        defaultMessage: "Reload to try again"
    }
});
const $5af5774e7bfbd5b4$var$styles = {
    errorState: "_4c065UVa5s _2Y7lL45zaO _0jFU0VN91d",
    reloadButton: "_30huDKYbGa _4c065UPgdg _2Y7lL4Pgdg _0KLXru66of _3iDTPbS8kF _1UtDYzM7Tp _0wOv4Q7zJH"
}; /**
    * Text-only counterpart to ChatGenericError implemented for the context panel.
    * This is to avoid an unnecessary bundle size increase with ChatGenericError's illustration
    */ 
const $5af5774e7bfbd5b4$var$SessionRightPanelErrorState = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($5af5774e7bfbd5b4$var$messages.errorTitle);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage($5af5774e7bfbd5b4$var$messages.reloadLink);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $5af5774e7bfbd5b4$var$styles.reloadButton,
            onClick: $5af5774e7bfbd5b4$var$_temp
        }, t2));
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            xcss: $5af5774e7bfbd5b4$var$styles.errorState,
            testId: "conversation-assistant-session-context-panel-error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            alignInline: "center"
        }, t1, t3));
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        alignItems: "center",
        justifyContent: "center",
        xcss: $5af5774e7bfbd5b4$var$styles.errorState,
        testId: "conversation-assistant-session-context-panel-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, formatMessage($5af5774e7bfbd5b4$var$messages.errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $5af5774e7bfbd5b4$var$styles.reloadButton,
        onClick: ()=>{
            window.location.reload();
        }
    }, formatMessage($5af5774e7bfbd5b4$var$messages.reloadLink)))));
};
const $5af5774e7bfbd5b4$export$737accd84056f0b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5af5774e7bfbd5b4$var$SessionRightPanelErrorState, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== sendAnalyticsEvent) {
        t2 = (error)=>{
            (0, $hlvTd.logException)({
                exception: error,
                name: "sessionContextPanel",
                tags: {
                    teamName: "deliveroo"
                }
            });
            sendAnalyticsEvent({
                eventType: "operational",
                action: "failed",
                actionSubject: "sessionContextPanel",
                attributes: {
                    errorMessage: error.message
                }
            });
        };
        $[1] = sendAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t1,
            onError: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5af5774e7bfbd5b4$var$SessionRightPanelErrorState, null),
        onError: (error)=>{
            (0, $hlvTd.logException)({
                exception: error,
                name: 'sessionContextPanel',
                tags: {
                    teamName: 'deliveroo'
                }
            });
            sendAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'sessionContextPanel',
                attributes: {
                    errorMessage: error.message
                }
            });
        }
    }, children);
};
function $5af5774e7bfbd5b4$var$_temp() {
    window.location.reload();
}
module.exports["SessionRightPanelErrorBoundary"] = $5af5774e7bfbd5b4$export$737accd84056f0b;

});

parcelRegister("Vl9MW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $c519d749112a26b1$export$a0bce28b49dab85d = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("bvRMP")).then((module)=>({
            default: module.SessionRightPanel
        })));
module.exports["SessionRightPanelLazy"] = $c519d749112a26b1$export$a0bce28b49dab85d;

});

parcelRegister("bvRMP", function(module, exports) {

let $861c4fd6f045ac55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $861c4fd6f045ac55$var$load("35mvB"),
    $861c4fd6f045ac55$var$load("aLwQm"),
    $861c4fd6f045ac55$var$load("7BHAC"),
    $861c4fd6f045ac55$var$load("N3TvS"),
    $861c4fd6f045ac55$var$load("fAvNQ"),
    $861c4fd6f045ac55$var$load("hUbK8"),
    $861c4fd6f045ac55$var$load("1BcpX"),
    $861c4fd6f045ac55$var$load("dt9uc"),
    $861c4fd6f045ac55$var$load("j2Pq3"),
    $861c4fd6f045ac55$var$load("hS8gF"),
    $861c4fd6f045ac55$var$load("g8A75"),
    $861c4fd6f045ac55$var$load("4AElS"),
    $861c4fd6f045ac55$var$load("7G12e"),
    $861c4fd6f045ac55$var$load("1Gr4q"),
    $861c4fd6f045ac55$var$load("dChty"),
    $861c4fd6f045ac55$var$load("60a9E"),
    $861c4fd6f045ac55$var$load("59hV4"),
    $861c4fd6f045ac55$var$load("cN2rp"),
    $861c4fd6f045ac55$var$load("jmTCk"),
    $861c4fd6f045ac55$var$load("keazL"),
    $861c4fd6f045ac55$var$load("dhXIT"),
    $861c4fd6f045ac55$var$load("iWnyc"),
    $861c4fd6f045ac55$var$load("ea3NB"),
    $861c4fd6f045ac55$var$load("fuOfV"),
    $861c4fd6f045ac55$var$load("jL1Ke"),
    $861c4fd6f045ac55$var$load("5MQ0D"),
    $861c4fd6f045ac55$var$load("cvcNg"),
    $861c4fd6f045ac55$var$load("iZR3N"),
    $861c4fd6f045ac55$var$load("jXM1T"),
    $861c4fd6f045ac55$var$load("aIze1"),
    $861c4fd6f045ac55$var$load("4N1MY"),
    $861c4fd6f045ac55$var$load("7A87G"),
    $861c4fd6f045ac55$var$load("6wr18"),
    $861c4fd6f045ac55$var$load("ffEVr"),
    $861c4fd6f045ac55$var$load("hhss7"),
    $861c4fd6f045ac55$var$load("gnocL"),
    $861c4fd6f045ac55$var$load("fwbNS"),
    $861c4fd6f045ac55$var$load("f0CsL"),
    $861c4fd6f045ac55$var$load("56OxX"),
    $861c4fd6f045ac55$var$load("Wowvf"),
    $861c4fd6f045ac55$var$load("4g6rd"),
    $861c4fd6f045ac55$var$load("7EorR"),
    $861c4fd6f045ac55$var$load("5CO1V")
]).then(()=>parcelRequire('lBYt7'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("6FfVp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $lWpNe = parcelRequire("lWpNe");


var $i6htE = parcelRequire("i6htE");

const $5b8c79aaf8c3f9d7$var$styles = {
    root: "_0jFU0VN91d _39xV02N91d _24h04i2Njc _2WAcuGIZbP",
    wrapper: "_2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _313842kG2W _1DCdHikG2W _2XsHFMkG2W _0adFHskG2W",
    card: "_0bjKvDyzSk _4bt5LAoWuR _2WAcuGoWuR _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc",
    row: "_2mHwu88HPE _4c065U8HPE _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3",
    borderBottom: "_3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
    cardBody: "_4c065U8HPE _2Y7lL45zaO",
    timelineRow: "_3iDTPbgBM8 _2iEGP2sM9l _17lj8p8HPE _0hPCNLFlnN",
    rail: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02oWWg",
    connector: "_39xV024Jdh _2O5Vij7dHp _0KLXruDMqu",
    timelineText: "_1wydGW5zaO _4ouGXIdnbC",
    section: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    artefactRow: "_2mHwu88HPE _0bjKvDyzSk _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4kiQYA9LX5"
};
/** Agent context and Rovo Space rows of the Context card. */ const $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS = [
    {
        labelWidth: 112,
        descriptionWidth: 88,
        trailingWidth: 16
    },
    {
        labelWidth: 96,
        descriptionWidth: 104,
        trailingWidth: 16
    }
];
/** Entries of the expanded progress timeline. */ const $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS = [
    {
        titleWidth: 120,
        descriptionWidth: 168
    },
    {
        titleWidth: 96
    },
    {
        titleWidth: 140,
        descriptionWidth: 72
    },
    {
        titleWidth: 104
    }
];
const $5b8c79aaf8c3f9d7$var$ARTEFACT_ROWS = [
    {
        titleWidth: 150
    },
    {
        titleWidth: 190
    }
];
const $5b8c79aaf8c3f9d7$var$HeadingSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { width: width } = t0;
    let t1;
    if ($[0] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: width,
            height: 16,
            isShimmering: true
        });
        $[0] = width;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: width,
        height: 16,
        isShimmering: true
    });
const $5b8c79aaf8c3f9d7$export$659bc7cd6c22a575 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWpNe.FeedbackBanner), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.section
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
            width: 56
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: 32,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        t2 = (0, $iDrrr.fg)("asx_experimental_components") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
            width: 64
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 44,
            height: 20,
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 16,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.cardBody
        }, $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS.map($5b8c79aaf8c3f9d7$var$_temp)));
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
            width: 52
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 16,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.card
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.cardBody
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, $5b8c79aaf8c3f9d7$var$ARTEFACT_ROWS.map($5b8c79aaf8c3f9d7$var$_temp2))));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.wrapper
        }, t0, t1, t2, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
            width: 60
        })), $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS.map($5b8c79aaf8c3f9d7$var$_temp3)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i6htE.SmartLinkCardSkeleton), null)));
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWpNe.FeedbackBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.section
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
        width: 56
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), (0, $iDrrr.fg)('asx_experimental_components') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
        width: 64
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 44,
        height: 20,
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.cardBody
    }, $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS.map(({ titleWidth: titleWidth, descriptionWidth: descriptionWidth }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: titleWidth,
            xcss: $5b8c79aaf8c3f9d7$var$styles.timelineRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.rail
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 16,
            height: 16,
            borderRadius: "var(--ds-radius-full, 9999px)",
            isShimmering: true
        }), index < $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.connector
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b8c79aaf8c3f9d7$var$styles.timelineText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: titleWidth,
            height: 14,
            isShimmering: true
        }), descriptionWidth !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: descriptionWidth,
            height: 12,
            isShimmering: true
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
        width: 52
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.cardBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, $5b8c79aaf8c3f9d7$var$ARTEFACT_ROWS.map(({ titleWidth: titleWidth_0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: titleWidth_0,
            xcss: $5b8c79aaf8c3f9d7$var$styles.artefactRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: titleWidth_0,
            height: 14,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 100,
            height: 12,
            isShimmering: true
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, $5b8c79aaf8c3f9d7$var$styles.borderBottom)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b8c79aaf8c3f9d7$var$HeadingSkeleton, {
        width: 60
    })), $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS.map(({ labelWidth: labelWidth, descriptionWidth: descriptionWidth_0, trailingWidth: trailingWidth }, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: labelWidth,
            xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, index_0 < $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS.length - 1 && $5b8c79aaf8c3f9d7$var$styles.borderBottom)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: labelWidth,
            height: 16,
            isShimmering: true
        }), descriptionWidth_0 !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: descriptionWidth_0,
            height: 12,
            isShimmering: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: trailingWidth,
            height: 16,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i6htE.SmartLinkCardSkeleton), null)));
function $5b8c79aaf8c3f9d7$var$_temp(t0, index) {
    const { titleWidth: titleWidth, descriptionWidth: descriptionWidth } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: titleWidth,
        xcss: $5b8c79aaf8c3f9d7$var$styles.timelineRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.rail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-full, 9999px)",
        isShimmering: true
    }), index < $5b8c79aaf8c3f9d7$var$PROGRESS_ROWS.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.connector
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b8c79aaf8c3f9d7$var$styles.timelineText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: titleWidth,
        height: 14,
        isShimmering: true
    }), descriptionWidth !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: descriptionWidth,
        height: 12,
        isShimmering: true
    }))));
}
function $5b8c79aaf8c3f9d7$var$_temp2(t0) {
    const { titleWidth: titleWidth_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: titleWidth_0,
        xcss: $5b8c79aaf8c3f9d7$var$styles.artefactRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: titleWidth_0,
        height: 14,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 100,
        height: 12,
        isShimmering: true
    })));
}
function $5b8c79aaf8c3f9d7$var$_temp3(t0, index_0) {
    const { labelWidth: labelWidth, descriptionWidth: descriptionWidth_0, trailingWidth: trailingWidth } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: labelWidth,
        xcss: (0, $w6R6I.cx)($5b8c79aaf8c3f9d7$var$styles.row, index_0 < $5b8c79aaf8c3f9d7$var$CONTEXT_ROWS.length - 1 && $5b8c79aaf8c3f9d7$var$styles.borderBottom)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: labelWidth,
        height: 16,
        isShimmering: true
    }), descriptionWidth_0 !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: descriptionWidth_0,
        height: 12,
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: trailingWidth,
        height: 16,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }));
}
module.exports["SessionRightPanelSkeleton"] = $5b8c79aaf8c3f9d7$export$659bc7cd6c22a575;

});

parcelRegister("lWpNe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $d012be43ff57fdc3$var$styles = {
    root: "_0bjKvDyzSk _4c065U8HPE _2Y7lL45zaO _0KLXruzHaB _2fwxA5DIqT"
};
const $d012be43ff57fdc3$var$messages = (0, $kSwu1.defineMessages)({
    feedbackBannerText: {
        id: "ai-mate.conversation-assistant.session-right-panel.feedback-banner-text-non-final",
        defaultMessage: "\uD83E\uDDEA Internal experiment - Don't demo externally {feedbackChannelLink}"
    }
});
const $d012be43ff57fdc3$export$362b733259f0b9ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "span",
            weight: "bold",
            color: "color.text.inverse"
        }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: "https://atlassian.enterprise.slack.com/archives/C0BK8TXT3S5",
            target: "_blank",
            rel: "noopener noreferrer",
            appearance: "inverse"
        }, "#feedback-agent-session-experience"));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage($d012be43ff57fdc3$var$messages.feedbackBannerText, {
            feedbackChannelLink: t0
        });
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d012be43ff57fdc3$var$styles.root
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.inverse"
        }, t1));
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d012be43ff57fdc3$var$styles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.inverse"
    }, formatMessage($d012be43ff57fdc3$var$messages.feedbackBannerText, {
        feedbackChannelLink: /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "span",
            weight: "bold",
            color: "color.text.inverse"
        }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            href: "https://atlassian.enterprise.slack.com/archives/C0BK8TXT3S5",
            target: "_blank",
            rel: "noopener noreferrer",
            appearance: "inverse"
        }, "#feedback-agent-session-experience"))
    })));
};
module.exports["FeedbackBanner"] = $d012be43ff57fdc3$export$362b733259f0b9ed;

});

parcelRegister("i6htE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $755fb07bffbdea29$var$styles = {
    card: "_2mHwu88HPE _0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _4kiQYAFFh0 _39xV02N91d _24h04i2Njc _0LQT5E8HPE _03SyCP8HPE _0KLXrulfZc"
};
const $755fb07bffbdea29$export$b809446cefbba987 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 32,
            height: 32,
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 180,
            height: 16,
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: 120,
            height: 12,
            isShimmering: true
        }));
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $755fb07bffbdea29$var$styles.card,
            testId: testId
        }, t1, t2);
        $[2] = testId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $755fb07bffbdea29$var$styles.card,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 32,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 180,
        height: 16,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: 120,
        height: 12,
        isShimmering: true
    })));
module.exports["SmartLinkCardSkeleton"] = $755fb07bffbdea29$export$b809446cefbba987;

});

parcelRegister("axKZp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $l3wuH = parcelRequire("l3wuH");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");


var $iMnC5 = parcelRequire("iMnC5");


var $dSCNl = parcelRequire("dSCNl");


var $iiDOK = parcelRequire("iiDOK");


var $cSfOO = parcelRequire("cSfOO");


var $Vl9MW = parcelRequire("Vl9MW");


var $6FfVp = parcelRequire("6FfVp");

const $579ae2552509f6a5$var$messages = (0, $kSwu1.defineMessages)({
    contextPanelLabel: {
        id: "ai-mate.conversation-assistant.session-context-panel-drawer.label-non-final",
        defaultMessage: "Context panel"
    },
    closeContextPanelLabel: {
        id: "ai-mate.conversation-assistant.session-context-panel-drawer.close-label-non-final",
        defaultMessage: "Hide context"
    }
});
const $579ae2552509f6a5$var$styles = {
    sideNavContent: "_1mT5xdWVPG _2IhTonPgdg _4ApkO2Pgdg _0Bm75GPgdg _42Yu6B7dHp _4bt5LAnQyn",
    backdropCover: "_0bjKvDOLYo _3OE6xYPgdg",
    rightTray: "_39xV02N91d",
    trayNonFullscreen: "_1EqgXlE1Ft",
    trayFullscreen: "_1EqgXl715P",
    panel: "_3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0KLXrulfZc",
    panelMiniModal: "_0bjKvDuMRm _0KLXruqi9L",
    toolbar: "_3iDTPbQ4SZ _3YEZNOdnbC _0hPCNLDIqT _37wbyuz9WS _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    body: "_2O5Vij7dHp _4kiQYAdnbC"
};
// The scrim is authored with `@compiled/react` because `@atlaskit/css`'s typed `cssMap` does not
// expose this token as an allowed `backgroundColor` value. Uses the same token as the hamburger
// side-nav backdrop so the two menus dim the surface identically.
const $579ae2552509f6a5$var$backdropStyles = null;
const $579ae2552509f6a5$export$a00c723d48325325 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { isOpen: isOpen, isMiniModal: t1 } = t0;
    const isMiniModal = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { closeSessionContext: closeSessionContext } = (0, $iiDOK.useSplitView)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    let t2;
    if ($[0] !== closeSessionContext || $[1] !== formatMessage || $[2] !== fullScreen || $[3] !== isMiniModal || $[4] !== isOpen) {
        t2 = isOpen && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("button", {
            type: "button",
            "aria-label": formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
            onClick: closeSessionContext,
            className: (0, $hekY6.default)([
                $579ae2552509f6a5$var$styles.sideNavContent,
                $579ae2552509f6a5$var$styles.backdropCover,
                "_30huDKdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrushJp _0wOv4Q7zJH"
            ])
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($579ae2552509f6a5$var$styles.sideNavContent, $579ae2552509f6a5$var$styles.rightTray, fullScreen ? $579ae2552509f6a5$var$styles.trayFullscreen : $579ae2552509f6a5$var$styles.trayNonFullscreen),
            testId: "conversation-assistant-session-context-panel-drawer",
            role: "dialog",
            "aria-label": formatMessage($579ae2552509f6a5$var$messages.contextPanelLabel)
        }, /*#__PURE__*/ $cozmU.createElement((0, $j72ee.default), {
            enterFrom: "right",
            exitTo: "right",
            fade: "inout",
            duration: "medium"
        }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                ...animationProps,
                style: {
                    ...animationProps.style,
                    height: "100%"
                }
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $579ae2552509f6a5$var$styles.panel,
                    isMiniModal && $579ae2552509f6a5$var$styles.panelMiniModal
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $579ae2552509f6a5$var$styles.toolbar
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                testId: "conversation-assistant-session-context-panel-drawer-close-button",
                shape: "circle",
                appearance: "subtle",
                isTooltipDisabled: false,
                label: formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                onClick: closeSessionContext
            })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $579ae2552509f6a5$var$styles.body
            }, /*#__PURE__*/ $cozmU.createElement((0, $cSfOO.SessionRightPanelErrorBoundary), null, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ $cozmU.createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
            }, /*#__PURE__*/ $cozmU.createElement((0, $Vl9MW.SessionRightPanelLazy), null)))))))));
        $[0] = closeSessionContext;
        $[1] = formatMessage;
        $[2] = fullScreen;
        $[3] = isMiniModal;
        $[4] = isOpen;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ isOpen: isOpen, isMiniModal: isMiniModal = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { closeSessionContext: closeSessionContext } = (0, $iiDOK.useSplitView)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("button", {
        type: "button",
        "aria-label": formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
        onClick: closeSessionContext,
        className: (0, $hekY6.default)([
            $579ae2552509f6a5$var$styles.sideNavContent,
            $579ae2552509f6a5$var$styles.backdropCover,
            "_30huDKdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrushJp _0wOv4Q7zJH"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($579ae2552509f6a5$var$styles.sideNavContent, $579ae2552509f6a5$var$styles.rightTray, fullScreen ? $579ae2552509f6a5$var$styles.trayFullscreen : $579ae2552509f6a5$var$styles.trayNonFullscreen),
        testId: "conversation-assistant-session-context-panel-drawer",
        role: "dialog",
        "aria-label": formatMessage($579ae2552509f6a5$var$messages.contextPanelLabel)
    }, /*#__PURE__*/ $cozmU.createElement((0, $j72ee.default), {
        enterFrom: "right",
        exitTo: "right",
        fade: "inout",
        duration: "medium"
    }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
            ...animationProps,
            style: {
                ...animationProps.style,
                height: '100%'
            }
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $579ae2552509f6a5$var$styles.panel,
                isMiniModal && $579ae2552509f6a5$var$styles.panelMiniModal
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $579ae2552509f6a5$var$styles.toolbar
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            testId: "conversation-assistant-session-context-panel-drawer-close-button",
            shape: "circle",
            appearance: "subtle",
            isTooltipDisabled: false,
            label: formatMessage($579ae2552509f6a5$var$messages.closeContextPanelLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            onClick: closeSessionContext
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $579ae2552509f6a5$var$styles.body
        }, /*#__PURE__*/ $cozmU.createElement((0, $cSfOO.SessionRightPanelErrorBoundary), null, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ $cozmU.createElement((0, $6FfVp.SessionRightPanelSkeleton), null)
        }, /*#__PURE__*/ $cozmU.createElement((0, $Vl9MW.SessionRightPanelLazy), null))))))))));
};
module.exports["SessionContextPanelDrawer"] = $579ae2552509f6a5$export$a00c723d48325325;

});


//# sourceMappingURL=main.571eb048.js.map
